webpackJsonp([231608221292675],{

/***/ "./.cache/api-runner-browser.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.apiRunner = apiRunner;
	exports.apiRunnerAsync = apiRunnerAsync;
	var plugins = [{
	  plugin: __webpack_require__("./node_modules/gatsby-plugin-glamor/gatsby-browser.js"),
	  options: { "plugins": [] }
	}, {
	  plugin: __webpack_require__("./node_modules/gatsby-plugin-typography/gatsby-browser.js"),
	  options: { "plugins": [], "pathToConfigModule": "src/utils/typography" }
	}];
	// During bootstrap, we write requires at top of this file which looks
	// basically like:
	// var plugins = [
	//   require('/path/to/plugin1/gatsby-browser.js'),
	//   require('/path/to/plugin2/gatsby-browser.js'),
	// ]
	
	function apiRunner(api, args, defaultReturn) {
	  var results = plugins.map(function (plugin) {
	    if (plugin.plugin[api]) {
	      var result = plugin.plugin[api](args, plugin.options);
	      return result;
	    }
	  });
	
	  // Filter out undefined results.
	  results = results.filter(function (result) {
	    return typeof result !== 'undefined';
	  });
	
	  if (results.length > 0) {
	    return results;
	  } else if (defaultReturn) {
	    return [defaultReturn];
	  } else {
	    return [];
	  }
	}
	
	function apiRunnerAsync(api, args, defaultReturn) {
	  return plugins.reduce(function (previous, next) {
	    return next.plugin[api] ? previous.then(function () {
	      return next.plugin[api](args, next.options);
	    }) : previous;
	  }, Promise.resolve());
	}

/***/ }),

/***/ "./.cache/async-requires.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _exports$json;
	
	// prefer default export if available
	var preferDefault = function preferDefault(m) {
	  return m && m.default || m;
	};
	
	exports.components = {
	  "component---src-templates-blog-post-index-js": __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=component---src-templates-blog-post-index-js!./src/templates/BlogPost/index.js"),
	  "component---src-templates-generic-post-index-js": __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=component---src-templates-generic-post-index-js!./src/templates/GenericPost/index.js"),
	  "component---src-templates-feature-index-js": __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=component---src-templates-feature-index-js!./src/templates/Feature/index.js"),
	  "component---src-templates-case-study-index-js": __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=component---src-templates-case-study-index-js!./src/templates/CaseStudy/index.js"),
	  "component---src-pages-404-js": __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=component---src-pages-404-js!./src/pages/404.js"),
	  "component---src-pages-index-js": __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=component---src-pages-index-js!./src/pages/index.js"),
	  "component---src-pages-blog-index-js": __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=component---src-pages-blog-index-js!./src/pages/blog/index.js"),
	  "component---src-pages-case-studies-index-js": __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=component---src-pages-case-studies-index-js!./src/pages/case-studies/index.js"),
	  "component---src-pages-features-index-js": __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=component---src-pages-features-index-js!./src/pages/features/index.js"),
	  "component---src-pages-contact-us-index-js": __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=component---src-pages-contact-us-index-js!./src/pages/contact-us/index.js")
	};
	
	exports.json = (_exports$json = {
	  "layout-index.json": __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---!./.cache/json/layout-index.json"),
	  "blog-who-cares-about-social-care.json": __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---blog-who-cares-about-social-care!./.cache/json/blog-who-cares-about-social-care.json")
	}, _exports$json["layout-index.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---!./.cache/json/layout-index.json"), _exports$json["shiftplanning-software.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---shiftplanning-software!./.cache/json/shiftplanning-software.json"), _exports$json["layout-index.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---!./.cache/json/layout-index.json"), _exports$json["software-for-home-care-services.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---software-for-home-care-services!./.cache/json/software-for-home-care-services.json"), _exports$json["layout-index.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---!./.cache/json/layout-index.json"), _exports$json["features-customisation.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---features-customisation!./.cache/json/features-customisation.json"), _exports$json["layout-index.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---!./.cache/json/layout-index.json"), _exports$json["features-record-keeping.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---features-record-keeping!./.cache/json/features-record-keeping.json"), _exports$json["layout-index.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---!./.cache/json/layout-index.json"), _exports$json["features-communication.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---features-communication!./.cache/json/features-communication.json"), _exports$json["layout-index.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---!./.cache/json/layout-index.json"), _exports$json["features-travel.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---features-travel!./.cache/json/features-travel.json"), _exports$json["layout-index.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---!./.cache/json/layout-index.json"), _exports$json["features-reporting.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---features-reporting!./.cache/json/features-reporting.json"), _exports$json["layout-index.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---!./.cache/json/layout-index.json"), _exports$json["features-invoicing-and-payments.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---features-invoicing-and-payments!./.cache/json/features-invoicing-and-payments.json"), _exports$json["layout-index.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---!./.cache/json/layout-index.json"), _exports$json["features-secure-cloud-based-system.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---features-secure-cloud-based-system!./.cache/json/features-secure-cloud-based-system.json"), _exports$json["layout-index.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---!./.cache/json/layout-index.json"), _exports$json["features-drag-and-drop-rostering.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---features-drag-and-drop-rostering!./.cache/json/features-drag-and-drop-rostering.json"), _exports$json["layout-index.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---!./.cache/json/layout-index.json"), _exports$json["features-mobile.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---features-mobile!./.cache/json/features-mobile.json"), _exports$json["layout-index.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---!./.cache/json/layout-index.json"), _exports$json["features-call-monitoring.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---features-call-monitoring!./.cache/json/features-call-monitoring.json"), _exports$json["layout-index.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---!./.cache/json/layout-index.json"), _exports$json["terms-and-conditions.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---terms-and-conditions!./.cache/json/terms-and-conditions.json"), _exports$json["layout-index.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---!./.cache/json/layout-index.json"), _exports$json["case-studies-woodfield-24.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---case-studies-woodfield-24!./.cache/json/case-studies-woodfield-24.json"), _exports$json["layout-index.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---!./.cache/json/layout-index.json"), _exports$json["case-studies-sos-homecare.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---case-studies-sos-homecare!./.cache/json/case-studies-sos-homecare.json"), _exports$json["layout-index.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---!./.cache/json/layout-index.json"), _exports$json["case-studies-county-care.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---case-studies-county-care!./.cache/json/case-studies-county-care.json"), _exports$json["layout-index.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---!./.cache/json/layout-index.json"), _exports$json["case-studies-charlesworth-community-care.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---case-studies-charlesworth-community-care!./.cache/json/case-studies-charlesworth-community-care.json"), _exports$json["layout-index.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---!./.cache/json/layout-index.json"), _exports$json["case-studies-proud-to-care.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---case-studies-proud-to-care!./.cache/json/case-studies-proud-to-care.json"), _exports$json["layout-index.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---!./.cache/json/layout-index.json"), _exports$json["404.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---404!./.cache/json/404.json"), _exports$json["layout-index.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---!./.cache/json/layout-index.json"), _exports$json["index.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---index!./.cache/json/index.json"), _exports$json["layout-index.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---!./.cache/json/layout-index.json"), _exports$json["404-html.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---404-html!./.cache/json/404-html.json"), _exports$json["layout-index.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---!./.cache/json/layout-index.json"), _exports$json["blog.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---blog!./.cache/json/blog.json"), _exports$json["layout-index.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---!./.cache/json/layout-index.json"), _exports$json["case-studies.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---case-studies!./.cache/json/case-studies.json"), _exports$json["layout-index.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---!./.cache/json/layout-index.json"), _exports$json["features.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---features!./.cache/json/features.json"), _exports$json["layout-index.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---!./.cache/json/layout-index.json"), _exports$json["contact-us.json"] = __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=path---contact-us!./.cache/json/contact-us.json"), _exports$json);
	
	exports.layouts = {
	  "component---src-layouts-index-js": __webpack_require__("./node_modules/gatsby-module-loader/index.js?name=component---src-layouts-index-js!./.cache/layouts/index.js")
	};

/***/ }),

/***/ "./.cache/component-renderer.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _loader = __webpack_require__("./.cache/loader.js");
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _emitter = __webpack_require__("./.cache/emitter.js");
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DefaultLayout = function DefaultLayout(_ref) {
	  var children = _ref.children;
	  return Glamor.createElement(
	    "div",
	    null,
	    children()
	  );
	};
	
	// Pass pathname in as prop.
	// component will try fetching resources. If they exist,
	// will just render, else will render null.
	
	var ComponentRenderer = function (_React$Component) {
	  _inherits(ComponentRenderer, _React$Component);
	
	  function ComponentRenderer(props) {
	    _classCallCheck(this, ComponentRenderer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      location: props.location,
	      pageResources: _loader2.default.getResourcesForPathname(props.location.pathname)
	    };
	    return _this;
	  }
	
	  ComponentRenderer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    if (this.state.location.pathname !== nextProps.location.pathname) {
	      var pageResources = _loader2.default.getResourcesForPathname(nextProps.location.pathname);
	      if (!pageResources) {
	        // Page resources won't be set in cases where the browser back button
	        // or forward button is pushed as we can't wait as normal for resources
	        // to load before changing the page.
	        _loader2.default.getResourcesForPathname(nextProps.location.pathname, function (pageResources) {
	          _this2.setState({
	            location: nextProps.location,
	            pageResources: pageResources
	          });
	        });
	      } else {
	        this.setState({
	          location: nextProps.location,
	          pageResources: pageResources
	        });
	      }
	    }
	  };
	
	  ComponentRenderer.prototype.componentDidMount = function componentDidMount() {
	    var _this3 = this;
	
	    // Listen to events so when our page gets updated, we can transition.
	    // This is only useful on delayed transitions as the page will get rendered
	    // without the necessary page resources and then re-render once those come in.
	    _emitter2.default.on("onPostLoadPageResources", function (e) {
	      if (e.page.path === _loader2.default.getPage(_this3.state.location.pathname).path) {
	        _this3.setState({ pageResources: e.pageResources });
	      }
	    });
	  };
	
	  ComponentRenderer.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	    // 404
	    if (!nextState.pageResources) {
	      return true;
	    }
	
	    // Check if the component or json have changed.
	    if (!this.state.pageResources && nextState.pageResources) {
	      return true;
	    }
	
	    if (this.state.pageResources.component !== nextState.pageResources.component) {
	      return true;
	    }
	
	    if (this.state.pageResources.json !== nextState.pageResources.json) {
	      return true;
	    }
	
	    // Check if location has changed on a page using internal routing
	    // via matchPath configuration.
	    if (this.state.location.key !== nextState.location.key && nextState.pageResources.page && (nextState.pageResources.page.matchPath || nextState.pageResources.page.path)) {
	      return true;
	    }
	
	    return false;
	  };
	
	  ComponentRenderer.prototype.render = function render() {
	    // If page.
	    if (this.props.page) {
	      if (this.state.pageResources) {
	        return (0, _react.createElement)(this.state.pageResources.component, _extends({
	          key: this.props.location.pathname
	        }, this.props, this.state.pageResources.json));
	      } else {
	        return null;
	      }
	      // If layout.
	    } else if (this.props.layout) {
	      return (0, _react.createElement)(this.state.pageResources && this.state.pageResources.layout ? this.state.pageResources.layout : DefaultLayout, _extends({
	        key: this.state.pageResources && this.state.pageResources.layout ? this.state.pageResources.layout : "DefaultLayout"
	      }, this.props));
	    } else {
	      return null;
	    }
	  };
	
	  return ComponentRenderer;
	}(_react2.default.Component);
	
	ComponentRenderer.propTypes = {
	  page: _propTypes2.default.bool,
	  layout: _propTypes2.default.bool,
	  location: _propTypes2.default.object
	};
	
	exports.default = ComponentRenderer;
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./.cache/emitter.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _mitt = __webpack_require__("./node_modules/mitt/dist/mitt.js");
	
	var _mitt2 = _interopRequireDefault(_mitt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emitter = (0, _mitt2.default)();
	module.exports = emitter;

/***/ }),

/***/ "./.cache/find-page.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _reactRouterDom = __webpack_require__("./node_modules/react-router-dom/index.js");
	
	var pageCache = {}; // TODO add tests especially for handling prefixed links.
	
	
	module.exports = function (pages) {
	  var pathPrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	  return function (rawPathname) {
	    var pathname = decodeURIComponent(rawPathname);
	    // Remove the pathPrefix from the pathname.
	    var trimmedPathname = pathname.slice(pathPrefix.length);
	
	    // Remove any hashfragment
	    if (trimmedPathname.split("#").length > 1) {
	      trimmedPathname = trimmedPathname.split("#").slice(0, -1).join("");
	    }
	
	    // Remove search query
	    if (trimmedPathname.split("?").length > 1) {
	      trimmedPathname = trimmedPathname.split("?").slice(0, -1).join("");
	    }
	
	    if (pageCache[trimmedPathname]) {
	      return pageCache[trimmedPathname];
	    }
	
	    var foundPage = void 0;
	    // Array.prototype.find is not supported in IE so we use this somewhat odd
	    // work around.
	    pages.some(function (page) {
	      if (page.matchPath) {
	        // Try both the path and matchPath
	        if ((0, _reactRouterDom.matchPath)(trimmedPathname, { path: page.path }) || (0, _reactRouterDom.matchPath)(trimmedPathname, {
	          path: page.matchPath
	        })) {
	          foundPage = page;
	          pageCache[trimmedPathname] = page;
	          return true;
	        }
	      } else {
	        if ((0, _reactRouterDom.matchPath)(trimmedPathname, {
	          path: page.path,
	          exact: true
	        })) {
	          foundPage = page;
	          pageCache[trimmedPathname] = page;
	          return true;
	        }
	      }
	
	      return false;
	    });
	
	    return foundPage;
	  };
	};

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=path---404-html!./.cache/json/404-html.json":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(178698757827068, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/404-html.json") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=path---404!./.cache/json/404.json":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(254022195166212, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/404.json") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=path---blog-who-cares-about-social-care!./.cache/json/blog-who-cares-about-social-care.json":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(45260344286074, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/blog-who-cares-about-social-care.json") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=path---blog!./.cache/json/blog.json":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(49683490770531, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/blog.json") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=path---case-studies-charlesworth-community-care!./.cache/json/case-studies-charlesworth-community-care.json":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(28172810555824, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/case-studies-charlesworth-community-care.json") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=path---case-studies-county-care!./.cache/json/case-studies-county-care.json":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(268601633285562, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/case-studies-county-care.json") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=path---case-studies-proud-to-care!./.cache/json/case-studies-proud-to-care.json":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(168424950393311, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/case-studies-proud-to-care.json") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=path---case-studies-sos-homecare!./.cache/json/case-studies-sos-homecare.json":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(35750476099034, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/case-studies-sos-homecare.json") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=path---case-studies-woodfield-24!./.cache/json/case-studies-woodfield-24.json":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(103719186566043, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/case-studies-woodfield-24.json") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=path---case-studies!./.cache/json/case-studies.json":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(130887140839456, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/case-studies.json") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=path---contact-us!./.cache/json/contact-us.json":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(274272988595999, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/contact-us.json") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=path---features-call-monitoring!./.cache/json/features-call-monitoring.json":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(198316295818936, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/features-call-monitoring.json") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=path---features-communication!./.cache/json/features-communication.json":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(9318767603557, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/features-communication.json") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=path---features-customisation!./.cache/json/features-customisation.json":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(9015346929108, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/features-customisation.json") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=path---features-drag-and-drop-rostering!./.cache/json/features-drag-and-drop-rostering.json":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(171113947089687, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/features-drag-and-drop-rostering.json") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=path---features-invoicing-and-payments!./.cache/json/features-invoicing-and-payments.json":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(228020265517317, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/features-invoicing-and-payments.json") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=path---features-mobile!./.cache/json/features-mobile.json":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(214408606680982, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/features-mobile.json") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=path---features-record-keeping!./.cache/json/features-record-keeping.json":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(33492762603732, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/features-record-keeping.json") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=path---features-reporting!./.cache/json/features-reporting.json":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(258035752542838, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/features-reporting.json") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=path---features-secure-cloud-based-system!./.cache/json/features-secure-cloud-based-system.json":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(274239991999587, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/features-secure-cloud-based-system.json") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=path---features-travel!./.cache/json/features-travel.json":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(169341531490272, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/features-travel.json") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=path---features!./.cache/json/features.json":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(56980643304056, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/features.json") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=path---index!./.cache/json/index.json":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(142629428675168, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/index.json") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=path---!./.cache/json/layout-index.json":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(60335399758886, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/layout-index.json") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=path---shiftplanning-software!./.cache/json/shiftplanning-software.json":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(181711007726214, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/shiftplanning-software.json") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=path---software-for-home-care-services!./.cache/json/software-for-home-care-services.json":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(57824197585063, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/software-for-home-care-services.json") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=path---terms-and-conditions!./.cache/json/terms-and-conditions.json":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(111860568745148, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/terms-and-conditions.json") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=component---src-layouts-index-js!./.cache/layouts/index.js":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(114276838955818, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dale/Documents/cp-website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-transform-object-assign/lib/index.js\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"glamor/babel-hoist\"],\"presets\":[[\"/Users/dale/Documents/cp-website/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/dale/Documents/cp-website/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./.cache/layouts/index.js") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./.cache/loader.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _findPage = __webpack_require__("./.cache/find-page.js");
	
	var _findPage2 = _interopRequireDefault(_findPage);
	
	var _emitter = __webpack_require__("./.cache/emitter.js");
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var findPage = void 0;
	
	var syncRequires = {};
	var asyncRequires = {};
	var pathScriptsCache = {};
	var resourceStrCache = {};
	var resourceCache = {};
	var pages = [];
	// Note we're not actively using the path data atm. There
	// could be future optimizations however around trying to ensure
	// we load all resources for likely-to-be-visited paths.
	var pathArray = [];
	var pathCount = {};
	var resourcesArray = [];
	var resourcesCount = {};
	var preferDefault = function preferDefault(m) {
	  return m && m.default || m;
	};
	var prefetcher = void 0;
	var inInitialRender = true;
	
	// Prefetcher logic
	if (true) {
	  prefetcher = __webpack_require__("./.cache/prefetcher.js")({
	    getNextQueuedResources: function getNextQueuedResources() {
	      return resourcesArray.slice(-1)[0];
	    },
	    createResourceDownload: function createResourceDownload(resourceName) {
	      fetchResource(resourceName, function () {
	        resourcesArray = resourcesArray.filter(function (r) {
	          return r !== resourceName;
	        });
	        prefetcher.onResourcedFinished(resourceName);
	      });
	    }
	  });
	  _emitter2.default.on("onPreLoadPageResources", function (e) {
	    prefetcher.onPreLoadPageResources(e);
	  });
	  _emitter2.default.on("onPostLoadPageResources", function (e) {
	    prefetcher.onPostLoadPageResources(e);
	  });
	}
	
	var sortResourcesByCount = function sortResourcesByCount(a, b) {
	  if (resourcesCount[a] > resourcesCount[b]) {
	    return 1;
	  } else if (resourcesCount[a] < resourcesCount[b]) {
	    return -1;
	  } else {
	    return 0;
	  }
	};
	
	var sortPagesByCount = function sortPagesByCount(a, b) {
	  if (pathCount[a] > pathCount[b]) {
	    return 1;
	  } else if (pathCount[a] < pathCount[b]) {
	    return -1;
	  } else {
	    return 0;
	  }
	};
	
	var fetchResource = function fetchResource(resourceName) {
	  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	
	  if (resourceStrCache[resourceName]) {
	    process.nextTick(function () {
	      cb(null, resourceStrCache[resourceName]);
	    });
	  } else {
	    // Find resource
	    var resourceFunction = resourceName.slice(0, 12) === "component---" ? asyncRequires.components[resourceName] || asyncRequires.layouts[resourceName] : asyncRequires.json[resourceName];
	
	    // Download the resource
	    resourceFunction(function (err, executeChunk) {
	      resourceStrCache[resourceName] = executeChunk;
	      cb(err, executeChunk);
	    });
	  }
	};
	
	var getResourceModule = function getResourceModule(resourceName, cb) {
	  if (resourceCache[resourceName]) {
	    process.nextTick(function () {
	      cb(null, resourceCache[resourceName]);
	    });
	  } else {
	    fetchResource(resourceName, function (err, executeChunk) {
	      if (err) {
	        cb(err);
	      } else {
	        var _module = preferDefault(executeChunk());
	        resourceCache[resourceName] = _module;
	        cb(err, _module);
	      }
	    });
	  }
	};
	
	var mountOrder = 1;
	var queue = {
	  empty: function empty() {
	    pathArray = [];
	    pathCount = {};
	    resourcesCount = {};
	    resourcesArray = [];
	    pages = [];
	  },
	  addPagesArray: function addPagesArray(newPages) {
	    pages = newPages;
	    var pathPrefix = "";
	    if (true) {
	      pathPrefix = ("/cp-website");
	    }
	    findPage = (0, _findPage2.default)(newPages, pathPrefix);
	  },
	  addDevRequires: function addDevRequires(devRequires) {
	    syncRequires = devRequires;
	  },
	  addProdRequires: function addProdRequires(prodRequires) {
	    asyncRequires = prodRequires;
	  },
	  dequeue: function dequeue(path) {
	    return pathArray.pop();
	  },
	  enqueue: function enqueue(path) {
	    // Check page exists.
	    if (!pages.some(function (p) {
	      return p.path === path;
	    })) {
	      return false;
	    }
	
	    var mountOrderBoost = 1 / mountOrder;
	    mountOrder += 1;
	    // console.log(
	    // `enqueue "${path}", mountOrder: "${mountOrder}, mountOrderBoost: ${mountOrderBoost}`
	    // )
	
	    // Add to path counts.
	    if (!pathCount[path]) {
	      pathCount[path] = 1;
	    } else {
	      pathCount[path] += 1;
	    }
	
	    // Add path to queue.
	    if (!queue.has(path)) {
	      pathArray.unshift(path);
	    }
	
	    // Sort pages by pathCount
	    pathArray.sort(sortPagesByCount);
	
	    // Add resources to queue.
	    var page = findPage(path);
	    if (page.jsonName) {
	      if (!resourcesCount[page.jsonName]) {
	        resourcesCount[page.jsonName] = 1 + mountOrderBoost;
	      } else {
	        resourcesCount[page.jsonName] += 1 + mountOrderBoost;
	      }
	
	      // Before adding, checking that the JSON resource isn't either
	      // already queued or been downloading.
	      if (resourcesArray.indexOf(page.jsonName) === -1 && !resourceStrCache[page.jsonName]) {
	        resourcesArray.unshift(page.jsonName);
	      }
	    }
	    if (page.componentChunkName) {
	      if (!resourcesCount[page.componentChunkName]) {
	        resourcesCount[page.componentChunkName] = 1 + mountOrderBoost;
	      } else {
	        resourcesCount[page.componentChunkName] += 1 + mountOrderBoost;
	      }
	
	      // Before adding, checking that the component resource isn't either
	      // already queued or been downloading.
	      if (resourcesArray.indexOf(page.componentChunkName) === -1 && !resourceStrCache[page.jsonName]) {
	        resourcesArray.unshift(page.componentChunkName);
	      }
	    }
	
	    // Sort resources by resourcesCount.
	    resourcesArray.sort(sortResourcesByCount);
	    if (true) {
	      prefetcher.onNewResourcesAdded();
	    }
	
	    return true;
	  },
	  getResources: function getResources() {
	    return {
	      resourcesArray: resourcesArray,
	      resourcesCount: resourcesCount
	    };
	  },
	  getPages: function getPages() {
	    return {
	      pathArray: pathArray,
	      pathCount: pathCount
	    };
	  },
	  getPage: function getPage(pathname) {
	    return findPage(pathname);
	  },
	  has: function has(path) {
	    return pathArray.some(function (p) {
	      return p === path;
	    });
	  },
	  getResourcesForPathname: function getResourcesForPathname(path) {
	    var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	
	    if (inInitialRender && navigator && navigator.serviceWorker && navigator.serviceWorker.controller && navigator.serviceWorker.controller.state === "activated") {
	      // If we're loading from a service worker (it's already activated on
	      // this initial render) and we can't find a page, there's a good chance
	      // we're on a new page that this (now old) service worker doesn't know
	      // about so we'll unregister it and reload.
	      if (!findPage(path)) {
	        navigator.serviceWorker.getRegistrations().then(function (registrations) {
	          for (var _iterator = registrations, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref;
	
	            if (_isArray) {
	              if (_i >= _iterator.length) break;
	              _ref = _iterator[_i++];
	            } else {
	              _i = _iterator.next();
	              if (_i.done) break;
	              _ref = _i.value;
	            }
	
	            var registration = _ref;
	
	            registration.unregister();
	          }
	          window.location.reload();
	        });
	      }
	    }
	    inInitialRender = false;
	    // In development we know the code is loaded already
	    // so we just return with it immediately.
	    if (false) {
	      var page = findPage(path);
	      if (!page) return cb();
	      var pageResources = {
	        component: syncRequires.components[page.componentChunkName],
	        json: syncRequires.json[page.jsonName],
	        layout: syncRequires.layouts[page.layoutComponentChunkName],
	        page: page
	      };
	      cb(pageResources);
	      return pageResources;
	      // Production code path
	    } else {
	      var _page = findPage(path);
	
	      if (!_page) {
	        console.log("A page wasn't found for \"" + path + "\"");
	        return;
	      }
	
	      // Use the path from the page so the pathScriptsCache uses
	      // the normalized path.
	      path = _page.path;
	
	      // Check if it's in the cache already.
	      if (pathScriptsCache[path]) {
	        process.nextTick(function () {
	          cb(pathScriptsCache[path]);
	          _emitter2.default.emit("onPostLoadPageResources", {
	            page: _page,
	            pageResources: pathScriptsCache[path]
	          });
	        });
	        return pathScriptsCache[path];
	      }
	
	      _emitter2.default.emit("onPreLoadPageResources", { path: path });
	      // Nope, we need to load resource(s)
	      var component = void 0;
	      var json = void 0;
	      var layout = void 0;
	      // Load the component/json/layout and parallel and call this
	      // function when they're done loading. When both are loaded,
	      // we move on.
	      var done = function done() {
	        if (component && json && (!_page.layoutComponentChunkName || layout)) {
	          pathScriptsCache[path] = { component: component, json: json, layout: layout };
	          var _pageResources = { component: component, json: json, layout: layout };
	          cb(_pageResources);
	          _emitter2.default.emit("onPostLoadPageResources", {
	            page: _page,
	            pageResources: _pageResources
	          });
	        }
	      };
	      getResourceModule(_page.componentChunkName, function (err, c) {
	        if (err) {
	          console.log("Loading the component for " + _page.path + " failed");
	        }
	        component = c;
	        done();
	      });
	      getResourceModule(_page.jsonName, function (err, j) {
	        if (err) {
	          console.log("Loading the JSON for " + _page.path + " failed");
	        }
	        json = j;
	        done();
	      });
	
	      _page.layoutComponentChunkName && getResourceModule(_page.layoutComponentChunkName, function (err, l) {
	        if (err) {
	          console.log("Loading the Layout for " + _page.path + " failed");
	        }
	        layout = l;
	        done();
	      });
	
	      return undefined;
	    }
	  },
	  peek: function peek(path) {
	    return pathArray.slice(-1)[0];
	  },
	  length: function length() {
	    return pathArray.length;
	  },
	  indexOf: function indexOf(path) {
	    return pathArray.length - pathArray.indexOf(path) - 1;
	  }
	};
	
	module.exports = queue;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./.cache/pages.json":
/***/ (function(module, exports) {

	module.exports = [{"componentChunkName":"component---src-templates-blog-post-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-who-cares-about-social-care.json","path":"/blog/who-cares-about-social-care"},{"componentChunkName":"component---src-templates-generic-post-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"shiftplanning-software.json","path":"/shiftplanning-software"},{"componentChunkName":"component---src-templates-generic-post-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"software-for-home-care-services.json","path":"/software-for-home-care-services"},{"componentChunkName":"component---src-templates-feature-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"features-customisation.json","path":"/features/customisation"},{"componentChunkName":"component---src-templates-feature-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"features-record-keeping.json","path":"/features/record-keeping"},{"componentChunkName":"component---src-templates-feature-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"features-communication.json","path":"/features/communication"},{"componentChunkName":"component---src-templates-feature-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"features-travel.json","path":"/features/travel"},{"componentChunkName":"component---src-templates-feature-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"features-reporting.json","path":"/features/reporting"},{"componentChunkName":"component---src-templates-feature-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"features-invoicing-and-payments.json","path":"/features/invoicing-and-payments"},{"componentChunkName":"component---src-templates-feature-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"features-secure-cloud-based-system.json","path":"/features/secure-cloud-based-system"},{"componentChunkName":"component---src-templates-feature-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"features-drag-and-drop-rostering.json","path":"/features/drag-and-drop-rostering"},{"componentChunkName":"component---src-templates-feature-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"features-mobile.json","path":"/features/mobile"},{"componentChunkName":"component---src-templates-feature-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"features-call-monitoring.json","path":"/features/call-monitoring"},{"componentChunkName":"component---src-templates-generic-post-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"terms-and-conditions.json","path":"/terms-and-conditions"},{"componentChunkName":"component---src-templates-case-study-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"case-studies-woodfield-24.json","path":"/case-studies/woodfield24"},{"componentChunkName":"component---src-templates-case-study-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"case-studies-sos-homecare.json","path":"/case-studies/sos-homecare"},{"componentChunkName":"component---src-templates-case-study-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"case-studies-county-care.json","path":"/case-studies/county-care"},{"componentChunkName":"component---src-templates-case-study-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"case-studies-charlesworth-community-care.json","path":"/case-studies/charlesworth-community-care"},{"componentChunkName":"component---src-templates-case-study-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"case-studies-proud-to-care.json","path":"/case-studies/proud-to-care"},{"componentChunkName":"component---src-pages-404-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"404.json","path":"/404/"},{"componentChunkName":"component---src-pages-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"index.json","path":"/"},{"componentChunkName":"component---src-pages-404-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"404-html.json","path":"/404.html"},{"componentChunkName":"component---src-pages-blog-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog.json","path":"/blog/"},{"componentChunkName":"component---src-pages-case-studies-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"case-studies.json","path":"/case-studies/"},{"componentChunkName":"component---src-pages-features-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"features.json","path":"/features/"},{"componentChunkName":"component---src-pages-contact-us-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"contact-us.json","path":"/contact-us/"}]

/***/ }),

/***/ "./.cache/prefetcher.js":
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (_ref) {
	  var getNextQueuedResources = _ref.getNextQueuedResources,
	      createResourceDownload = _ref.createResourceDownload;
	
	  var pagesLoading = [];
	  var resourcesDownloading = [];
	
	  // Do things
	  var startResourceDownloading = function startResourceDownloading() {
	    var nextResource = getNextQueuedResources();
	    if (nextResource) {
	      resourcesDownloading.push(nextResource);
	      createResourceDownload(nextResource);
	    }
	  };
	
	  var reducer = function reducer(action) {
	    switch (action.type) {
	      case "RESOURCE_FINISHED":
	        resourcesDownloading = resourcesDownloading.filter(function (r) {
	          return r !== action.payload;
	        });
	        break;
	      case "ON_PRE_LOAD_PAGE_RESOURCES":
	        pagesLoading.push(action.payload.path);
	        break;
	      case "ON_POST_LOAD_PAGE_RESOURCES":
	        pagesLoading = pagesLoading.filter(function (p) {
	          return p !== action.payload.page.path;
	        });
	        break;
	      case "ON_NEW_RESOURCES_ADDED":
	        break;
	    }
	
	    // Take actions.
	    // Wait for event loop queue to finish.
	    setTimeout(function () {
	      if (resourcesDownloading.length === 0 && pagesLoading.length === 0) {
	        // Start another resource downloading.
	        startResourceDownloading();
	      }
	    }, 0);
	  };
	
	  return {
	    onResourcedFinished: function onResourcedFinished(event) {
	      // Tell prefetcher that the resource finished downloading
	      // so it can grab the next one.
	      reducer({ type: "RESOURCE_FINISHED", payload: event });
	    },
	    onPreLoadPageResources: function onPreLoadPageResources(event) {
	      // Tell prefetcher a page load has started so it should stop
	      // loading anything new
	      reducer({ type: "ON_PRE_LOAD_PAGE_RESOURCES", payload: event });
	    },
	    onPostLoadPageResources: function onPostLoadPageResources(event) {
	      // Tell prefetcher a page load has finished so it should start
	      // loading resources again.
	      reducer({ type: "ON_POST_LOAD_PAGE_RESOURCES", payload: event });
	    },
	    onNewResourcesAdded: function onNewResourcesAdded() {
	      // Tell prefetcher that more resources to be downloaded have
	      // been added.
	      reducer({ type: "ON_NEW_RESOURCES_ADDED" });
	    },
	    getState: function getState() {
	      return { pagesLoading: pagesLoading, resourcesDownloading: resourcesDownloading };
	    },
	    empty: function empty() {
	      pagesLoading = [];
	      resourcesDownloading = [];
	    }
	  };
	};

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _apiRunnerBrowser = __webpack_require__("./.cache/api-runner-browser.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouterDom = __webpack_require__("./node_modules/react-router-dom/index.js");
	
	var _gatsbyReactRouterScroll = __webpack_require__("./node_modules/gatsby-react-router-scroll/index.js");
	
	var _createBrowserHistory = __webpack_require__("./node_modules/history/createBrowserHistory.js");
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _domready = __webpack_require__("./node_modules/domready/ready.js");
	
	var _domready2 = _interopRequireDefault(_domready);
	
	var _emitter = __webpack_require__("./.cache/emitter.js");
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _pages = __webpack_require__("./.cache/pages.json");
	
	var _pages2 = _interopRequireDefault(_pages);
	
	var _redirects = __webpack_require__("./.cache/redirects.json");
	
	var _redirects2 = _interopRequireDefault(_redirects);
	
	var _componentRenderer = __webpack_require__("./.cache/component-renderer.js");
	
	var _componentRenderer2 = _interopRequireDefault(_componentRenderer);
	
	var _asyncRequires = __webpack_require__("./.cache/async-requires.js");
	
	var _asyncRequires2 = _interopRequireDefault(_asyncRequires);
	
	var _loader = __webpack_require__("./.cache/loader.js");
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (true) {
	  __webpack_require__("./node_modules/core-js/modules/es6.promise.js");
	}
	
	window.___emitter = _emitter2.default;
	
	_loader2.default.addPagesArray(_pages2.default);
	_loader2.default.addProdRequires(_asyncRequires2.default);
	window.asyncRequires = _asyncRequires2.default;
	window.___loader = _loader2.default;
	window.matchPath = _reactRouterDom.matchPath;
	
	var history = (0, _createBrowserHistory2.default)();
	
	// Convert to a map for faster lookup in maybeRedirect()
	var redirectMap = _redirects2.default.reduce(function (map, redirect) {
	  map[redirect.fromPath] = redirect;
	  return map;
	}, {});
	
	var maybeRedirect = function maybeRedirect(pathname) {
	  var redirect = redirectMap[pathname];
	
	  if (redirect != null) {
	    history.replace(redirect.toPath);
	    return true;
	  } else {
	    return false;
	  }
	};
	
	// Check for initial page-load redirect
	maybeRedirect(window.location.pathname);
	
	// Let the site/plugins run code very early.
	(0, _apiRunnerBrowser.apiRunnerAsync)("onClientEntry").then(function () {
	  // Let plugins register a service worker. The plugin just needs
	  // to return true.
	  if ((0, _apiRunnerBrowser.apiRunner)("registerServiceWorker").length > 0) {
	    __webpack_require__("./.cache/register-service-worker.js");
	  }
	
	  var navigateTo = function navigateTo(pathname) {
	    var redirect = redirectMap[pathname];
	
	    // If we're redirecting, just replace the passed in pathname
	    // to the one we want to redirect to.
	    if (redirect) {
	      pathname = redirect.toPath;
	    }
	
	    // If we're already at this path, do nothing.
	    if (window.location.pathname === pathname) {
	      return;
	    }
	
	    // Listen to loading events. If page resources load before
	    // a second, navigate immediately.
	    function eventHandler(e) {
	      if (e.page.path === _loader2.default.getPage(pathname).path) {
	        _emitter2.default.off("onPostLoadPageResources", eventHandler);
	        clearTimeout(timeoutId);
	        window.___history.push(pathname);
	      }
	    }
	
	    // Start a timer to wait for a second before transitioning and showing a
	    // loader in case resources aren't around yet.
	    var timeoutId = setTimeout(function () {
	      _emitter2.default.off("onPostLoadPageResources", eventHandler);
	      _emitter2.default.emit("onDelayedLoadPageResources", { pathname: pathname });
	      window.___history.push(pathname);
	    }, 1000);
	
	    if (_loader2.default.getResourcesForPathname(pathname)) {
	      // The resources are already loaded so off we go.
	      clearTimeout(timeoutId);
	      window.___history.push(pathname);
	    } else {
	      // They're not loaded yet so let's add a listener for when
	      // they finish loading.
	      _emitter2.default.on("onPostLoadPageResources", eventHandler);
	    }
	  };
	
	  // window.___loadScriptsForPath = loadScriptsForPath
	  window.___navigateTo = navigateTo;
	
	  // Call onRouteUpdate on the initial page load.
	  (0, _apiRunnerBrowser.apiRunner)("onRouteUpdate", {
	    location: history.location,
	    action: history.action
	  });
	
	  function attachToHistory(history) {
	    if (!window.___history) {
	      window.___history = history;
	
	      history.listen(function (location, action) {
	        if (!maybeRedirect(location.pathname)) {
	          (0, _apiRunnerBrowser.apiRunner)("onRouteUpdate", { location: location, action: action });
	        }
	      });
	    }
	  }
	
	  function shouldUpdateScroll(prevRouterProps, _ref) {
	    var pathname = _ref.location.pathname;
	
	    var results = (0, _apiRunnerBrowser.apiRunner)("shouldUpdateScroll", {
	      prevRouterProps: prevRouterProps,
	      pathname: pathname
	    });
	    if (results.length > 0) {
	      return results[0];
	    }
	
	    if (prevRouterProps) {
	      var oldPathname = prevRouterProps.location.pathname;
	
	      if (oldPathname === pathname) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  var AltRouter = (0, _apiRunnerBrowser.apiRunner)("replaceRouterComponent", { history: history })[0];
	  var DefaultRouter = function DefaultRouter(_ref2) {
	    var children = _ref2.children;
	    return Glamor.createElement(
	      _reactRouterDom.Router,
	      { history: history },
	      children
	    );
	  };
	
	  _loader2.default.getResourcesForPathname(window.location.pathname, function () {
	    var Root = function Root() {
	      return (0, _react.createElement)(AltRouter ? AltRouter : DefaultRouter, null, (0, _react.createElement)(_gatsbyReactRouterScroll.ScrollContext, { shouldUpdateScroll: shouldUpdateScroll }, (0, _react.createElement)((0, _reactRouterDom.withRouter)(_componentRenderer2.default), {
	        layout: true,
	        children: function children(layoutProps) {
	          return (0, _react.createElement)(_reactRouterDom.Route, {
	            render: function render(routeProps) {
	              attachToHistory(routeProps.history);
	              var props = layoutProps ? layoutProps : routeProps;
	
	              if (_loader2.default.getPage(props.location.pathname)) {
	                return (0, _react.createElement)(_componentRenderer2.default, _extends({
	                  page: true
	                }, props));
	              } else {
	                return (0, _react.createElement)(_componentRenderer2.default, {
	                  location: { page: true, pathname: "/404.html" }
	                });
	              }
	            }
	          });
	        }
	      })));
	    };
	
	    var NewRoot = (0, _apiRunnerBrowser.apiRunner)("wrapRootComponent", { Root: Root }, Root)[0];
	    (0, _domready2.default)(function () {
	      return _reactDom2.default.render(Glamor.createElement(NewRoot, null), typeof window !== "undefined" ? document.getElementById("___gatsby") : void 0, function () {
	        (0, _apiRunnerBrowser.apiRunner)("onInitialClientRender");
	      });
	    });
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./.cache/redirects.json":
/***/ (function(module, exports) {

	module.exports = []

/***/ }),

/***/ "./.cache/register-service-worker.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _emitter = __webpack_require__("./.cache/emitter.js");
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pathPrefix = "/";
	if (true) {
	  pathPrefix = ("/cp-website") + "/";
	}
	
	if ("serviceWorker" in navigator) {
	  navigator.serviceWorker.register(pathPrefix + "sw.js").then(function (reg) {
	    reg.addEventListener("updatefound", function () {
	      // The updatefound event implies that reg.installing is set; see
	      // https://w3c.github.io/ServiceWorker/#service-worker-registration-updatefound-event
	      var installingWorker = reg.installing;
	      console.log("installingWorker", installingWorker);
	      installingWorker.addEventListener("statechange", function () {
	        switch (installingWorker.state) {
	          case "installed":
	            if (navigator.serviceWorker.controller) {
	              // At this point, the old content will have been purged and the fresh content will
	              // have been added to the cache.
	              // We reload immediately so the user sees the new content.
	              // This could/should be made configurable in the future.
	              window.location.reload();
	            } else {
	              // At this point, everything has been precached.
	              // It's the perfect time to display a "Content is cached for offline use." message.
	              console.log("Content is now available offline!");
	              _emitter2.default.emit("sw:installed");
	            }
	            break;
	
	          case "redundant":
	            console.error("The installing service worker became redundant.");
	            break;
	        }
	      });
	    });
	  }).catch(function (e) {
	    console.error("Error during service worker registration:", e);
	  });
	}

/***/ }),

/***/ "./node_modules/compass-vertical-rhythm/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.0
	var adjustFontSizeTo, convertLength, defaults, establishBaseline, linesForFontSize, objectAssign, parseUnit, rhythm, unit, unitLess;
	
	objectAssign = __webpack_require__("./node_modules/object-assign/index.js");
	
	convertLength = __webpack_require__("./node_modules/convert-css-length/dist/index.js");
	
	parseUnit = __webpack_require__("./node_modules/parse-unit/index.js");
	
	unit = function(length) {
	  return parseUnit(length)[1];
	};
	
	unitLess = function(length) {
	  return parseUnit(length)[0];
	};
	
	defaults = {
	  baseFontSize: '16px',
	  baseLineHeight: 1.5,
	  rhythmUnit: 'rem',
	  defaultRhythmBorderWidth: '1px',
	  defaultRhythmBorderStyle: 'solid',
	  roundToNearestHalfLine: true,
	  minLinePadding: '2px'
	};
	
	linesForFontSize = function(fontSize, options) {
	  var convert, fontSizeInPx, lineHeightInPx, lines, minLinePadding;
	  convert = convertLength(options.baseFontSize);
	  fontSizeInPx = unitLess(convert(fontSize, 'px'));
	  lineHeightInPx = unitLess(options.baseLineHeightInPx);
	  minLinePadding = unitLess(convert(options.minLinePadding, 'px'));
	  if (options.roundToNearestHalfLine) {
	    lines = Math.ceil(2 * fontSizeInPx / lineHeightInPx) / 2;
	  } else {
	    lines = Math.ceil(fontSizeInPx / lineHeightInPx);
	  }
	  if ((lines * lineHeightInPx - fontSizeInPx) < (minLinePadding * 2)) {
	    if (options.roundToNearestHalfLine) {
	      lines += 0.5;
	    } else {
	      lines += 1;
	    }
	  }
	  return lines;
	};
	
	rhythm = function(options) {
	  var convert;
	  convert = convertLength(options.baseFontSize);
	  return function(lines, fontSize, offset) {
	    var length, rhythmLength;
	    if (lines == null) {
	      lines = 1;
	    }
	    if (fontSize == null) {
	      fontSize = options.baseFontSize;
	    }
	    if (offset == null) {
	      offset = 0;
	    }
	    length = ((lines * unitLess(options.baseLineHeightInPx)) - offset) + "px";
	    rhythmLength = convert(length, options.rhythmUnit, fontSize);
	    if (unit(rhythmLength) === "px") {
	      rhythmLength = Math.floor(unitLess(rhythmLength)) + unit(rhythmLength);
	    }
	    return parseFloat(unitLess(rhythmLength).toFixed(5)) + unit(rhythmLength);
	  };
	};
	
	establishBaseline = function(options) {
	  var convert;
	  convert = convertLength(options.baseFontSize);
	  return {
	    fontSize: (unitLess(options.baseFontSize) / 16) * 100 + "%",
	    lineHeight: convert(options.baseLineHeightInPx, 'em')
	  };
	};
	
	adjustFontSizeTo = function(toSize, lines, fromSize, options) {
	  var convert, r;
	  if (fromSize == null) {
	    fromSize = options.baseFontSize;
	  }
	  if (unit(toSize) === "%") {
	    toSize = unitLess(options.baseFontSize) * (unitLess(toSize) / 100) + "px";
	  }
	  convert = convertLength(options.baseFontSize);
	  fromSize = convert(fromSize, 'px');
	  toSize = convert(toSize, 'px', fromSize);
	  r = rhythm(options);
	  if (lines === "auto") {
	    lines = linesForFontSize(toSize, options);
	  }
	  return {
	    fontSize: convert(toSize, options.rhythmUnit, fromSize),
	    lineHeight: r(lines, fromSize)
	  };
	};
	
	module.exports = function(options) {
	  var convert, defaultsCopy, fontSizeInPx, lineHeight;
	  defaultsCopy = JSON.parse(JSON.stringify(defaults));
	  options = objectAssign(defaultsCopy, options);
	  convert = convertLength(options.baseFontSize);
	  if (unit(options.baseLineHeight)) {
	    fontSizeInPx = unitLess(convert(options.baseFontSize, 'px'));
	    lineHeight = convert(options.baseLineHeight, 'px');
	    options.baseLineHeightInPx = lineHeight;
	    options.baseLineHeight = unitLess(lineHeight) / fontSizeInPx;
	  } else {
	    options.baseLineHeightInPx = (unitLess(options.baseFontSize) * options.baseLineHeight) + "px";
	  }
	  return {
	    rhythm: rhythm(options),
	    establishBaseline: function() {
	      return establishBaseline(options);
	    },
	    linesForFontSize: function(fontSize) {
	      return linesForFontSize(fontSize, options);
	    },
	    adjustFontSizeTo: function(toSize, lines, fromSize) {
	      if (lines == null) {
	        lines = "auto";
	      }
	      return adjustFontSizeTo(toSize, lines, fromSize, options);
	    }
	  };
	};


/***/ }),

/***/ "./node_modules/console-polyfill/index.js":
/***/ (function(module, exports) {

	// Console-polyfill. MIT license.
	// https://github.com/paulmillr/console-polyfill
	// Make it safe to do console.log() always.
	(function(con) {
	  'use strict';
	  var prop, method;
	  var empty = {};
	  var dummy = function() {};
	  var properties = 'memory'.split(',');
	  var methods = ('assert,clear,count,debug,dir,dirxml,error,exception,group,' +
	     'groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,' +
	     'show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn').split(',');
	  while (prop = properties.pop()) con[prop] = con[prop] || empty;
	  while (method = methods.pop()) con[method] = con[method] || dummy;
	})(this.console = this.console || {}); // Using `this` for web workers.


/***/ }),

/***/ "./node_modules/convert-css-length/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.0
	var baseFontSize, parseUnit, unit, unitLess;
	
	parseUnit = __webpack_require__("./node_modules/parse-unit/index.js");
	
	__webpack_require__("./node_modules/console-polyfill/index.js");
	
	baseFontSize = "16px";
	
	unit = function(length) {
	  return parseUnit(length)[1];
	};
	
	unitLess = function(length) {
	  return parseUnit(length)[0];
	};
	
	module.exports = function(baseFontSize) {
	  if (baseFontSize == null) {
	    baseFontSize = baseFontSize;
	  }
	  return function(length, toUnit, fromContext, toContext) {
	    var fromUnit, outputLength, pxLength;
	    if (fromContext == null) {
	      fromContext = baseFontSize;
	    }
	    if (toContext == null) {
	      toContext = fromContext;
	    }
	    fromUnit = unit(length);
	    if (fromUnit === toUnit) {
	      return length;
	    }
	    pxLength = unitLess(length);
	    if (unit(fromContext) !== "px") {
	      console.warn("Parameter fromContext must resolve to a value in pixel units.");
	    }
	    if (unit(toContext) !== "px") {
	      console.warn("Parameter toContext must resolve to a value in pixel units.");
	    }
	    if (fromUnit !== "px") {
	      if (fromUnit === "em") {
	        pxLength = unitLess(length) * unitLess(fromContext);
	      } else if (fromUnit === "rem") {
	        pxLength = unitLess(length) * unitLess(baseFontSize);
	      } else if (fromUnit === "ex") {
	        pxLength = unitLess(length) * unitLess(fromContext) * 2;
	      } else if (fromUnit === "ch" || fromUnit === "vw" || fromUnit === "vh" || fromUnit === "vmin") {
	        console.warn(fromUnit + " units can't be reliably converted; Returning original value.");
	        return length;
	      } else {
	        console.warn(fromUnit + " is an unknown or unsupported length unit; Returning original value.");
	        return length;
	      }
	    }
	    outputLength = pxLength;
	    if (toUnit !== "px") {
	      if (toUnit === "em") {
	        outputLength = pxLength / unitLess(toContext);
	      } else if (toUnit === "rem") {
	        outputLength = pxLength / unitLess(baseFontSize);
	      } else if (toUnit === "ex") {
	        outputLength = pxLength / unitLess(toContext) / 2;
	      } else if (toUnit === "ch" || toUnit === "vw" || toUnit === "vh" || toUnit === "vmin") {
	        console.warn(toUnit + " units can't be reliably converted; Returning original value.");
	        return length;
	      } else {
	        console.warn(toUnit + " is an unknown or unsupported length unit; Returning original value.");
	        return length;
	      }
	    }
	    return parseFloat(outputLength.toFixed(5)) + toUnit;
	  };
	};


/***/ }),

/***/ "./node_modules/decamelize/index.js":
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str, sep) {
		if (typeof str !== 'string') {
			throw new TypeError('Expected a string');
		}
	
		sep = typeof sep === 'undefined' ? '_' : sep;
	
		return str
			.replace(/([a-z\d])([A-Z])/g, '$1' + sep + '$2')
			.replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1' + sep + '$2')
			.toLowerCase();
	};


/***/ }),

/***/ "./node_modules/domready/ready.js":
/***/ (function(module, exports, __webpack_require__) {

	/*!
	  * domready (c) Dustin Diaz 2014 - License MIT
	  */
	!function (name, definition) {
	
	  if (true) module.exports = definition()
	  else if (typeof define == 'function' && typeof define.amd == 'object') define(definition)
	  else this[name] = definition()
	
	}('domready', function () {
	
	  var fns = [], listener
	    , doc = document
	    , hack = doc.documentElement.doScroll
	    , domContentLoaded = 'DOMContentLoaded'
	    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState)
	
	
	  if (!loaded)
	  doc.addEventListener(domContentLoaded, listener = function () {
	    doc.removeEventListener(domContentLoaded, listener)
	    loaded = 1
	    while (listener = fns.shift()) listener()
	  })
	
	  return function (fn) {
	    loaded ? setTimeout(fn, 0) : fns.push(fn)
	  }
	
	});


/***/ }),

/***/ "./node_modules/gatsby-module-loader/patch.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	patch();
	
	function patch() {
	  var head = document.querySelector("head");
	  var ensure = __webpack_require__.e;
	  var chunks = __webpack_require__.s;
	  var failures;
	
	  __webpack_require__.e = function (chunkId, callback) {
	    var loaded = false;
	    var immediate = true;
	
	    var handler = function handler(error) {
	      if (!callback) return;
	
	      callback(__webpack_require__, error);
	      callback = null;
	    };
	
	    if (!chunks && failures && failures[chunkId]) {
	      handler(true);
	      return;
	    }
	
	    ensure(chunkId, function () {
	      if (loaded) return;
	      loaded = true;
	
	      if (immediate) {
	        // webpack fires callback immediately if chunk was already loaded
	        // IE also fires callback immediately if script was already
	        // in a cache (AppCache counts too)
	        setTimeout(function () {
	          handler();
	        });
	      } else {
	        handler();
	      }
	    });
	
	    // This is |true| if chunk is already loaded and does not need onError call.
	    // This happens because in such case ensure() is performed in sync way
	    if (loaded) {
	      return;
	    }
	
	    immediate = false;
	
	    onError(function () {
	      if (loaded) return;
	      loaded = true;
	
	      if (chunks) {
	        chunks[chunkId] = void 0;
	      } else {
	        failures || (failures = {});
	        failures[chunkId] = true;
	      }
	
	      handler(true);
	    });
	  };
	
	  function onError(callback) {
	    var script = head.lastChild;
	
	    if (script.tagName !== "SCRIPT") {
	      if (typeof console !== "undefined" && console.warn) {
	        console.warn("Script is not a script", script);
	      }
	
	      return;
	    }
	
	    script.onload = script.onerror = function () {
	      script.onload = script.onerror = null;
	      setTimeout(callback, 0);
	    };
	  }
	}

/***/ }),

/***/ "./node_modules/gatsby-plugin-glamor/gatsby-browser.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _glamor = __webpack_require__("./node_modules/glamor/lib/index.js");
	
	exports.onClientEntry = function () {
	  if (window._glamor) {
	    (0, _glamor.rehydrate)(window._glamor);
	  }
	};

/***/ }),

/***/ "./node_modules/gatsby-plugin-typography/.cache/typography.js":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__("./src/utils/typography.js")

/***/ }),

/***/ "./node_modules/gatsby-plugin-typography/gatsby-browser.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typography = __webpack_require__("./node_modules/gatsby-plugin-typography/.cache/typography.js");
	
	var _typography2 = _interopRequireDefault(_typography);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Hot reload typography in development.
	if (false) {
	  _typography2.default.injectStyles();
	}

/***/ }),

/***/ "./node_modules/gray-percentage/index.js":
/***/ (function(module, exports) {

	function isNumeric(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	
	module.exports = function(lightness, hue, darkBackground) {
	  if (typeof hue === "undefined") {
	    hue = 0;
	  }
	  if (typeof darkBackground === "undefined") {
	    darkBackground = false;
	  }
	
	  // Convert named hues into numeric lightness value.
	  if (hue === "cool") {
	    hue = 237;
	  }
	  else if (hue === "slate") {
	    hue = 122;
	  }
	  else if (hue === "warm") {
	    hue = 69;
	  }
	
	  if (!isNumeric(hue)) {
	    throw new Error("Hue is not a number");
	  }
	
	  if (!isNumeric(lightness)) {
	    throw new Error("Lightness is not a number");
	  }
	
	  if (lightness > 100) {
	    lightness = 100;
	  }
	  if (lightness < 0) {
	    lightness = 0;
	  }
	
	  var saturation = 0;
	  if (hue !== 0) {
	    var a = 19.92978;
	    var b = -0.3651759;
	    var c = 0.001737214;
	    saturation = a + b * lightness + c * Math.pow(lightness, 2);
	  }
	
	  var opacity = 0
	  if (darkBackground) {
	    opacity = lightness / 100
	    lightness = '100%,'
	  } else {
	    opacity = (100 - lightness) / 100
	    lightness = '0%,'
	  }
	
	  return "hsla(" + hue + "," + saturation + "%," + lightness + opacity + ")";
	};


/***/ }),

/***/ "./node_modules/lodash.isnumber/index.js":
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	 * as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && objectToString.call(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ }),

/***/ "./node_modules/lodash/_DataView.js":
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"),
	    root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),

/***/ "./node_modules/lodash/_Hash.js":
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__("./node_modules/lodash/_hashClear.js"),
	    hashDelete = __webpack_require__("./node_modules/lodash/_hashDelete.js"),
	    hashGet = __webpack_require__("./node_modules/lodash/_hashGet.js"),
	    hashHas = __webpack_require__("./node_modules/lodash/_hashHas.js"),
	    hashSet = __webpack_require__("./node_modules/lodash/_hashSet.js");
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),

/***/ "./node_modules/lodash/_ListCache.js":
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__("./node_modules/lodash/_listCacheClear.js"),
	    listCacheDelete = __webpack_require__("./node_modules/lodash/_listCacheDelete.js"),
	    listCacheGet = __webpack_require__("./node_modules/lodash/_listCacheGet.js"),
	    listCacheHas = __webpack_require__("./node_modules/lodash/_listCacheHas.js"),
	    listCacheSet = __webpack_require__("./node_modules/lodash/_listCacheSet.js");
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),

/***/ "./node_modules/lodash/_Map.js":
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"),
	    root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),

/***/ "./node_modules/lodash/_MapCache.js":
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__("./node_modules/lodash/_mapCacheClear.js"),
	    mapCacheDelete = __webpack_require__("./node_modules/lodash/_mapCacheDelete.js"),
	    mapCacheGet = __webpack_require__("./node_modules/lodash/_mapCacheGet.js"),
	    mapCacheHas = __webpack_require__("./node_modules/lodash/_mapCacheHas.js"),
	    mapCacheSet = __webpack_require__("./node_modules/lodash/_mapCacheSet.js");
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),

/***/ "./node_modules/lodash/_Promise.js":
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"),
	    root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),

/***/ "./node_modules/lodash/_Set.js":
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"),
	    root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),

/***/ "./node_modules/lodash/_SetCache.js":
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__("./node_modules/lodash/_MapCache.js"),
	    setCacheAdd = __webpack_require__("./node_modules/lodash/_setCacheAdd.js"),
	    setCacheHas = __webpack_require__("./node_modules/lodash/_setCacheHas.js");
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),

/***/ "./node_modules/lodash/_Stack.js":
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__("./node_modules/lodash/_ListCache.js"),
	    stackClear = __webpack_require__("./node_modules/lodash/_stackClear.js"),
	    stackDelete = __webpack_require__("./node_modules/lodash/_stackDelete.js"),
	    stackGet = __webpack_require__("./node_modules/lodash/_stackGet.js"),
	    stackHas = __webpack_require__("./node_modules/lodash/_stackHas.js"),
	    stackSet = __webpack_require__("./node_modules/lodash/_stackSet.js");
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),

/***/ "./node_modules/lodash/_Symbol.js":
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),

/***/ "./node_modules/lodash/_Uint8Array.js":
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),

/***/ "./node_modules/lodash/_WeakMap.js":
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"),
	    root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),

/***/ "./node_modules/lodash/_apply.js":
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),

/***/ "./node_modules/lodash/_arrayEach.js":
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),

/***/ "./node_modules/lodash/_arrayFilter.js":
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),

/***/ "./node_modules/lodash/_arrayLikeKeys.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__("./node_modules/lodash/_baseTimes.js"),
	    isArguments = __webpack_require__("./node_modules/lodash/isArguments.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
	    isBuffer = __webpack_require__("./node_modules/lodash/isBuffer.js"),
	    isIndex = __webpack_require__("./node_modules/lodash/_isIndex.js"),
	    isTypedArray = __webpack_require__("./node_modules/lodash/isTypedArray.js");
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),

/***/ "./node_modules/lodash/_arrayMap.js":
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),

/***/ "./node_modules/lodash/_arrayPush.js":
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),

/***/ "./node_modules/lodash/_arrayReduce.js":
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ }),

/***/ "./node_modules/lodash/_arraySome.js":
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),

/***/ "./node_modules/lodash/_assignMergeValue.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__("./node_modules/lodash/_baseAssignValue.js"),
	    eq = __webpack_require__("./node_modules/lodash/eq.js");
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ }),

/***/ "./node_modules/lodash/_assignValue.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__("./node_modules/lodash/_baseAssignValue.js"),
	    eq = __webpack_require__("./node_modules/lodash/eq.js");
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),

/***/ "./node_modules/lodash/_assocIndexOf.js":
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__("./node_modules/lodash/eq.js");
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),

/***/ "./node_modules/lodash/_baseAssignValue.js":
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__("./node_modules/lodash/_defineProperty.js");
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),

/***/ "./node_modules/lodash/_baseCreate.js":
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__("./node_modules/lodash/isObject.js");
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),

/***/ "./node_modules/lodash/_baseEach.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__("./node_modules/lodash/_baseForOwn.js"),
	    createBaseEach = __webpack_require__("./node_modules/lodash/_createBaseEach.js");
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),

/***/ "./node_modules/lodash/_baseFor.js":
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__("./node_modules/lodash/_createBaseFor.js");
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),

/***/ "./node_modules/lodash/_baseForOwn.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__("./node_modules/lodash/_baseFor.js"),
	    keys = __webpack_require__("./node_modules/lodash/keys.js");
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),

/***/ "./node_modules/lodash/_baseGet.js":
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__("./node_modules/lodash/_castPath.js"),
	    toKey = __webpack_require__("./node_modules/lodash/_toKey.js");
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),

/***/ "./node_modules/lodash/_baseGetAllKeys.js":
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__("./node_modules/lodash/_arrayPush.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js");
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),

/***/ "./node_modules/lodash/_baseGetTag.js":
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js"),
	    getRawTag = __webpack_require__("./node_modules/lodash/_getRawTag.js"),
	    objectToString = __webpack_require__("./node_modules/lodash/_objectToString.js");
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),

/***/ "./node_modules/lodash/_baseHasIn.js":
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),

/***/ "./node_modules/lodash/_baseIsArguments.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),

/***/ "./node_modules/lodash/_baseIsEqual.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__("./node_modules/lodash/_baseIsEqualDeep.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),

/***/ "./node_modules/lodash/_baseIsEqualDeep.js":
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__("./node_modules/lodash/_Stack.js"),
	    equalArrays = __webpack_require__("./node_modules/lodash/_equalArrays.js"),
	    equalByTag = __webpack_require__("./node_modules/lodash/_equalByTag.js"),
	    equalObjects = __webpack_require__("./node_modules/lodash/_equalObjects.js"),
	    getTag = __webpack_require__("./node_modules/lodash/_getTag.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
	    isBuffer = __webpack_require__("./node_modules/lodash/isBuffer.js"),
	    isTypedArray = __webpack_require__("./node_modules/lodash/isTypedArray.js");
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),

/***/ "./node_modules/lodash/_baseIsMatch.js":
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__("./node_modules/lodash/_Stack.js"),
	    baseIsEqual = __webpack_require__("./node_modules/lodash/_baseIsEqual.js");
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),

/***/ "./node_modules/lodash/_baseIsNative.js":
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__("./node_modules/lodash/isFunction.js"),
	    isMasked = __webpack_require__("./node_modules/lodash/_isMasked.js"),
	    isObject = __webpack_require__("./node_modules/lodash/isObject.js"),
	    toSource = __webpack_require__("./node_modules/lodash/_toSource.js");
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),

/***/ "./node_modules/lodash/_baseIsTypedArray.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
	    isLength = __webpack_require__("./node_modules/lodash/isLength.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),

/***/ "./node_modules/lodash/_baseIteratee.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__("./node_modules/lodash/_baseMatches.js"),
	    baseMatchesProperty = __webpack_require__("./node_modules/lodash/_baseMatchesProperty.js"),
	    identity = __webpack_require__("./node_modules/lodash/identity.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
	    property = __webpack_require__("./node_modules/lodash/property.js");
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),

/***/ "./node_modules/lodash/_baseKeys.js":
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__("./node_modules/lodash/_isPrototype.js"),
	    nativeKeys = __webpack_require__("./node_modules/lodash/_nativeKeys.js");
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),

/***/ "./node_modules/lodash/_baseKeysIn.js":
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__("./node_modules/lodash/isObject.js"),
	    isPrototype = __webpack_require__("./node_modules/lodash/_isPrototype.js"),
	    nativeKeysIn = __webpack_require__("./node_modules/lodash/_nativeKeysIn.js");
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),

/***/ "./node_modules/lodash/_baseMatches.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__("./node_modules/lodash/_baseIsMatch.js"),
	    getMatchData = __webpack_require__("./node_modules/lodash/_getMatchData.js"),
	    matchesStrictComparable = __webpack_require__("./node_modules/lodash/_matchesStrictComparable.js");
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),

/***/ "./node_modules/lodash/_baseMatchesProperty.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__("./node_modules/lodash/_baseIsEqual.js"),
	    get = __webpack_require__("./node_modules/lodash/get.js"),
	    hasIn = __webpack_require__("./node_modules/lodash/hasIn.js"),
	    isKey = __webpack_require__("./node_modules/lodash/_isKey.js"),
	    isStrictComparable = __webpack_require__("./node_modules/lodash/_isStrictComparable.js"),
	    matchesStrictComparable = __webpack_require__("./node_modules/lodash/_matchesStrictComparable.js"),
	    toKey = __webpack_require__("./node_modules/lodash/_toKey.js");
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),

/***/ "./node_modules/lodash/_baseMerge.js":
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__("./node_modules/lodash/_Stack.js"),
	    assignMergeValue = __webpack_require__("./node_modules/lodash/_assignMergeValue.js"),
	    baseFor = __webpack_require__("./node_modules/lodash/_baseFor.js"),
	    baseMergeDeep = __webpack_require__("./node_modules/lodash/_baseMergeDeep.js"),
	    isObject = __webpack_require__("./node_modules/lodash/isObject.js"),
	    keysIn = __webpack_require__("./node_modules/lodash/keysIn.js");
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ }),

/***/ "./node_modules/lodash/_baseMergeDeep.js":
/***/ (function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__("./node_modules/lodash/_assignMergeValue.js"),
	    cloneBuffer = __webpack_require__("./node_modules/lodash/_cloneBuffer.js"),
	    cloneTypedArray = __webpack_require__("./node_modules/lodash/_cloneTypedArray.js"),
	    copyArray = __webpack_require__("./node_modules/lodash/_copyArray.js"),
	    initCloneObject = __webpack_require__("./node_modules/lodash/_initCloneObject.js"),
	    isArguments = __webpack_require__("./node_modules/lodash/isArguments.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
	    isArrayLikeObject = __webpack_require__("./node_modules/lodash/isArrayLikeObject.js"),
	    isBuffer = __webpack_require__("./node_modules/lodash/isBuffer.js"),
	    isFunction = __webpack_require__("./node_modules/lodash/isFunction.js"),
	    isObject = __webpack_require__("./node_modules/lodash/isObject.js"),
	    isPlainObject = __webpack_require__("./node_modules/lodash/isPlainObject.js"),
	    isTypedArray = __webpack_require__("./node_modules/lodash/isTypedArray.js"),
	    toPlainObject = __webpack_require__("./node_modules/lodash/toPlainObject.js");
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = object[key],
	      srcValue = source[key],
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ }),

/***/ "./node_modules/lodash/_baseProperty.js":
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),

/***/ "./node_modules/lodash/_basePropertyDeep.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__("./node_modules/lodash/_baseGet.js");
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),

/***/ "./node_modules/lodash/_baseReduce.js":
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.reduce` and `_.reduceRight`, without support
	 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initAccum Specify using the first or last element of
	 *  `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initAccum
	      ? (initAccum = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseReduce;


/***/ }),

/***/ "./node_modules/lodash/_baseRest.js":
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__("./node_modules/lodash/identity.js"),
	    overRest = __webpack_require__("./node_modules/lodash/_overRest.js"),
	    setToString = __webpack_require__("./node_modules/lodash/_setToString.js");
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),

/***/ "./node_modules/lodash/_baseSet.js":
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__("./node_modules/lodash/_assignValue.js"),
	    castPath = __webpack_require__("./node_modules/lodash/_castPath.js"),
	    isIndex = __webpack_require__("./node_modules/lodash/_isIndex.js"),
	    isObject = __webpack_require__("./node_modules/lodash/isObject.js"),
	    toKey = __webpack_require__("./node_modules/lodash/_toKey.js");
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ }),

/***/ "./node_modules/lodash/_baseSetToString.js":
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__("./node_modules/lodash/constant.js"),
	    defineProperty = __webpack_require__("./node_modules/lodash/_defineProperty.js"),
	    identity = __webpack_require__("./node_modules/lodash/identity.js");
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),

/***/ "./node_modules/lodash/_baseTimes.js":
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),

/***/ "./node_modules/lodash/_baseToString.js":
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js"),
	    arrayMap = __webpack_require__("./node_modules/lodash/_arrayMap.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
	    isSymbol = __webpack_require__("./node_modules/lodash/isSymbol.js");
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),

/***/ "./node_modules/lodash/_baseUnary.js":
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),

/***/ "./node_modules/lodash/_cacheHas.js":
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),

/***/ "./node_modules/lodash/_castFunction.js":
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__("./node_modules/lodash/identity.js");
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ }),

/***/ "./node_modules/lodash/_castPath.js":
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
	    isKey = __webpack_require__("./node_modules/lodash/_isKey.js"),
	    stringToPath = __webpack_require__("./node_modules/lodash/_stringToPath.js"),
	    toString = __webpack_require__("./node_modules/lodash/toString.js");
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),

/***/ "./node_modules/lodash/_cloneArrayBuffer.js":
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__("./node_modules/lodash/_Uint8Array.js");
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),

/***/ "./node_modules/lodash/_cloneBuffer.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/lodash/_cloneTypedArray.js":
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__("./node_modules/lodash/_cloneArrayBuffer.js");
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),

/***/ "./node_modules/lodash/_copyArray.js":
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),

/***/ "./node_modules/lodash/_copyObject.js":
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__("./node_modules/lodash/_assignValue.js"),
	    baseAssignValue = __webpack_require__("./node_modules/lodash/_baseAssignValue.js");
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),

/***/ "./node_modules/lodash/_coreJsData.js":
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),

/***/ "./node_modules/lodash/_createAssigner.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__("./node_modules/lodash/_baseRest.js"),
	    isIterateeCall = __webpack_require__("./node_modules/lodash/_isIterateeCall.js");
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),

/***/ "./node_modules/lodash/_createBaseEach.js":
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js");
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),

/***/ "./node_modules/lodash/_createBaseFor.js":
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),

/***/ "./node_modules/lodash/_defineProperty.js":
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__("./node_modules/lodash/_getNative.js");
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),

/***/ "./node_modules/lodash/_equalArrays.js":
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__("./node_modules/lodash/_SetCache.js"),
	    arraySome = __webpack_require__("./node_modules/lodash/_arraySome.js"),
	    cacheHas = __webpack_require__("./node_modules/lodash/_cacheHas.js");
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),

/***/ "./node_modules/lodash/_equalByTag.js":
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js"),
	    Uint8Array = __webpack_require__("./node_modules/lodash/_Uint8Array.js"),
	    eq = __webpack_require__("./node_modules/lodash/eq.js"),
	    equalArrays = __webpack_require__("./node_modules/lodash/_equalArrays.js"),
	    mapToArray = __webpack_require__("./node_modules/lodash/_mapToArray.js"),
	    setToArray = __webpack_require__("./node_modules/lodash/_setToArray.js");
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),

/***/ "./node_modules/lodash/_equalObjects.js":
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__("./node_modules/lodash/_getAllKeys.js");
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),

/***/ "./node_modules/lodash/_freeGlobal.js":
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ "./node_modules/lodash/_getAllKeys.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__("./node_modules/lodash/_baseGetAllKeys.js"),
	    getSymbols = __webpack_require__("./node_modules/lodash/_getSymbols.js"),
	    keys = __webpack_require__("./node_modules/lodash/keys.js");
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),

/***/ "./node_modules/lodash/_getMapData.js":
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__("./node_modules/lodash/_isKeyable.js");
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),

/***/ "./node_modules/lodash/_getMatchData.js":
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__("./node_modules/lodash/_isStrictComparable.js"),
	    keys = __webpack_require__("./node_modules/lodash/keys.js");
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),

/***/ "./node_modules/lodash/_getNative.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__("./node_modules/lodash/_baseIsNative.js"),
	    getValue = __webpack_require__("./node_modules/lodash/_getValue.js");
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),

/***/ "./node_modules/lodash/_getPrototype.js":
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__("./node_modules/lodash/_overArg.js");
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),

/***/ "./node_modules/lodash/_getRawTag.js":
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js");
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),

/***/ "./node_modules/lodash/_getSymbols.js":
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__("./node_modules/lodash/_arrayFilter.js"),
	    stubArray = __webpack_require__("./node_modules/lodash/stubArray.js");
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),

/***/ "./node_modules/lodash/_getTag.js":
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__("./node_modules/lodash/_DataView.js"),
	    Map = __webpack_require__("./node_modules/lodash/_Map.js"),
	    Promise = __webpack_require__("./node_modules/lodash/_Promise.js"),
	    Set = __webpack_require__("./node_modules/lodash/_Set.js"),
	    WeakMap = __webpack_require__("./node_modules/lodash/_WeakMap.js"),
	    baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
	    toSource = __webpack_require__("./node_modules/lodash/_toSource.js");
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),

/***/ "./node_modules/lodash/_getValue.js":
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),

/***/ "./node_modules/lodash/_hasPath.js":
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__("./node_modules/lodash/_castPath.js"),
	    isArguments = __webpack_require__("./node_modules/lodash/isArguments.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
	    isIndex = __webpack_require__("./node_modules/lodash/_isIndex.js"),
	    isLength = __webpack_require__("./node_modules/lodash/isLength.js"),
	    toKey = __webpack_require__("./node_modules/lodash/_toKey.js");
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),

/***/ "./node_modules/lodash/_hashClear.js":
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__("./node_modules/lodash/_nativeCreate.js");
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),

/***/ "./node_modules/lodash/_hashDelete.js":
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),

/***/ "./node_modules/lodash/_hashGet.js":
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__("./node_modules/lodash/_nativeCreate.js");
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),

/***/ "./node_modules/lodash/_hashHas.js":
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__("./node_modules/lodash/_nativeCreate.js");
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),

/***/ "./node_modules/lodash/_hashSet.js":
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__("./node_modules/lodash/_nativeCreate.js");
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),

/***/ "./node_modules/lodash/_initCloneObject.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__("./node_modules/lodash/_baseCreate.js"),
	    getPrototype = __webpack_require__("./node_modules/lodash/_getPrototype.js"),
	    isPrototype = __webpack_require__("./node_modules/lodash/_isPrototype.js");
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),

/***/ "./node_modules/lodash/_isIndex.js":
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),

/***/ "./node_modules/lodash/_isIterateeCall.js":
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__("./node_modules/lodash/eq.js"),
	    isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js"),
	    isIndex = __webpack_require__("./node_modules/lodash/_isIndex.js"),
	    isObject = __webpack_require__("./node_modules/lodash/isObject.js");
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),

/***/ "./node_modules/lodash/_isKey.js":
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
	    isSymbol = __webpack_require__("./node_modules/lodash/isSymbol.js");
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),

/***/ "./node_modules/lodash/_isKeyable.js":
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),

/***/ "./node_modules/lodash/_isMasked.js":
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__("./node_modules/lodash/_coreJsData.js");
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),

/***/ "./node_modules/lodash/_isPrototype.js":
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),

/***/ "./node_modules/lodash/_isStrictComparable.js":
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__("./node_modules/lodash/isObject.js");
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),

/***/ "./node_modules/lodash/_listCacheClear.js":
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),

/***/ "./node_modules/lodash/_listCacheDelete.js":
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__("./node_modules/lodash/_assocIndexOf.js");
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),

/***/ "./node_modules/lodash/_listCacheGet.js":
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__("./node_modules/lodash/_assocIndexOf.js");
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),

/***/ "./node_modules/lodash/_listCacheHas.js":
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__("./node_modules/lodash/_assocIndexOf.js");
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),

/***/ "./node_modules/lodash/_listCacheSet.js":
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__("./node_modules/lodash/_assocIndexOf.js");
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheClear.js":
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__("./node_modules/lodash/_Hash.js"),
	    ListCache = __webpack_require__("./node_modules/lodash/_ListCache.js"),
	    Map = __webpack_require__("./node_modules/lodash/_Map.js");
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheDelete.js":
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__("./node_modules/lodash/_getMapData.js");
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheGet.js":
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__("./node_modules/lodash/_getMapData.js");
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheHas.js":
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__("./node_modules/lodash/_getMapData.js");
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheSet.js":
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__("./node_modules/lodash/_getMapData.js");
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),

/***/ "./node_modules/lodash/_mapToArray.js":
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),

/***/ "./node_modules/lodash/_matchesStrictComparable.js":
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),

/***/ "./node_modules/lodash/_memoizeCapped.js":
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__("./node_modules/lodash/memoize.js");
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),

/***/ "./node_modules/lodash/_nativeCreate.js":
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__("./node_modules/lodash/_getNative.js");
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),

/***/ "./node_modules/lodash/_nativeKeys.js":
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__("./node_modules/lodash/_overArg.js");
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),

/***/ "./node_modules/lodash/_nativeKeysIn.js":
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),

/***/ "./node_modules/lodash/_nodeUtil.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__("./node_modules/lodash/_freeGlobal.js");
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/lodash/_objectToString.js":
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),

/***/ "./node_modules/lodash/_overArg.js":
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),

/***/ "./node_modules/lodash/_overRest.js":
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__("./node_modules/lodash/_apply.js");
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),

/***/ "./node_modules/lodash/_root.js":
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__("./node_modules/lodash/_freeGlobal.js");
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),

/***/ "./node_modules/lodash/_setCacheAdd.js":
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),

/***/ "./node_modules/lodash/_setCacheHas.js":
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),

/***/ "./node_modules/lodash/_setToArray.js":
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),

/***/ "./node_modules/lodash/_setToString.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__("./node_modules/lodash/_baseSetToString.js"),
	    shortOut = __webpack_require__("./node_modules/lodash/_shortOut.js");
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),

/***/ "./node_modules/lodash/_shortOut.js":
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),

/***/ "./node_modules/lodash/_stackClear.js":
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__("./node_modules/lodash/_ListCache.js");
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),

/***/ "./node_modules/lodash/_stackDelete.js":
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),

/***/ "./node_modules/lodash/_stackGet.js":
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),

/***/ "./node_modules/lodash/_stackHas.js":
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),

/***/ "./node_modules/lodash/_stackSet.js":
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__("./node_modules/lodash/_ListCache.js"),
	    Map = __webpack_require__("./node_modules/lodash/_Map.js"),
	    MapCache = __webpack_require__("./node_modules/lodash/_MapCache.js");
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),

/***/ "./node_modules/lodash/_stringToPath.js":
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__("./node_modules/lodash/_memoizeCapped.js");
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),

/***/ "./node_modules/lodash/_toKey.js":
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__("./node_modules/lodash/isSymbol.js");
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),

/***/ "./node_modules/lodash/_toSource.js":
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),

/***/ "./node_modules/lodash/constant.js":
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),

/***/ "./node_modules/lodash/eq.js":
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),

/***/ "./node_modules/lodash/forEach.js":
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__("./node_modules/lodash/_arrayEach.js"),
	    baseEach = __webpack_require__("./node_modules/lodash/_baseEach.js"),
	    castFunction = __webpack_require__("./node_modules/lodash/_castFunction.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js");
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ }),

/***/ "./node_modules/lodash/get.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__("./node_modules/lodash/_baseGet.js");
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),

/***/ "./node_modules/lodash/hasIn.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__("./node_modules/lodash/_baseHasIn.js"),
	    hasPath = __webpack_require__("./node_modules/lodash/_hasPath.js");
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),

/***/ "./node_modules/lodash/identity.js":
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),

/***/ "./node_modules/lodash/isArguments.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__("./node_modules/lodash/_baseIsArguments.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),

/***/ "./node_modules/lodash/isArray.js":
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),

/***/ "./node_modules/lodash/isArrayLike.js":
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__("./node_modules/lodash/isFunction.js"),
	    isLength = __webpack_require__("./node_modules/lodash/isLength.js");
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),

/***/ "./node_modules/lodash/isArrayLikeObject.js":
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ }),

/***/ "./node_modules/lodash/isBuffer.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__("./node_modules/lodash/_root.js"),
	    stubFalse = __webpack_require__("./node_modules/lodash/stubFalse.js");
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/lodash/isFunction.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
	    isObject = __webpack_require__("./node_modules/lodash/isObject.js");
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),

/***/ "./node_modules/lodash/isLength.js":
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),

/***/ "./node_modules/lodash/isNumber.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	 * classified as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && baseGetTag(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ }),

/***/ "./node_modules/lodash/isObject.js":
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),

/***/ "./node_modules/lodash/isObjectLike.js":
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),

/***/ "./node_modules/lodash/isPlainObject.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
	    getPrototype = __webpack_require__("./node_modules/lodash/_getPrototype.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),

/***/ "./node_modules/lodash/isString.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ }),

/***/ "./node_modules/lodash/isSymbol.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),

/***/ "./node_modules/lodash/isTypedArray.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__("./node_modules/lodash/_baseIsTypedArray.js"),
	    baseUnary = __webpack_require__("./node_modules/lodash/_baseUnary.js"),
	    nodeUtil = __webpack_require__("./node_modules/lodash/_nodeUtil.js");
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),

/***/ "./node_modules/lodash/keys.js":
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__("./node_modules/lodash/_arrayLikeKeys.js"),
	    baseKeys = __webpack_require__("./node_modules/lodash/_baseKeys.js"),
	    isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js");
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),

/***/ "./node_modules/lodash/keysIn.js":
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__("./node_modules/lodash/_arrayLikeKeys.js"),
	    baseKeysIn = __webpack_require__("./node_modules/lodash/_baseKeysIn.js"),
	    isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js");
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),

/***/ "./node_modules/lodash/memoize.js":
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__("./node_modules/lodash/_MapCache.js");
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),

/***/ "./node_modules/lodash/merge.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__("./node_modules/lodash/_baseMerge.js"),
	    createAssigner = __webpack_require__("./node_modules/lodash/_createAssigner.js");
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ }),

/***/ "./node_modules/lodash/property.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__("./node_modules/lodash/_baseProperty.js"),
	    basePropertyDeep = __webpack_require__("./node_modules/lodash/_basePropertyDeep.js"),
	    isKey = __webpack_require__("./node_modules/lodash/_isKey.js"),
	    toKey = __webpack_require__("./node_modules/lodash/_toKey.js");
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),

/***/ "./node_modules/lodash/reduce.js":
/***/ (function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__("./node_modules/lodash/_arrayReduce.js"),
	    baseEach = __webpack_require__("./node_modules/lodash/_baseEach.js"),
	    baseIteratee = __webpack_require__("./node_modules/lodash/_baseIteratee.js"),
	    baseReduce = __webpack_require__("./node_modules/lodash/_baseReduce.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js");
	
	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` thru `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not given, the first element of `collection` is used as the initial
	 * value. The iteratee is invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	 * and `sortBy`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @see _.reduceRight
	 * @example
	 *
	 * _.reduce([1, 2], function(sum, n) {
	 *   return sum + n;
	 * }, 0);
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 *   return result;
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	 */
	function reduce(collection, iteratee, accumulator) {
	  var func = isArray(collection) ? arrayReduce : baseReduce,
	      initAccum = arguments.length < 3;
	
	  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	}
	
	module.exports = reduce;


/***/ }),

/***/ "./node_modules/lodash/set.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseSet = __webpack_require__("./node_modules/lodash/_baseSet.js");
	
	/**
	 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	 * it's created. Arrays are created for missing index properties while objects
	 * are created for all other missing properties. Use `_.setWith` to customize
	 * `path` creation.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.set(object, 'a[0].b.c', 4);
	 * console.log(object.a[0].b.c);
	 * // => 4
	 *
	 * _.set(object, ['x', '0', 'y', 'z'], 5);
	 * console.log(object.x[0].y.z);
	 * // => 5
	 */
	function set(object, path, value) {
	  return object == null ? object : baseSet(object, path, value);
	}
	
	module.exports = set;


/***/ }),

/***/ "./node_modules/lodash/stubArray.js":
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),

/***/ "./node_modules/lodash/stubFalse.js":
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),

/***/ "./node_modules/lodash/toPlainObject.js":
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__("./node_modules/lodash/_copyObject.js"),
	    keysIn = __webpack_require__("./node_modules/lodash/keysIn.js");
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ }),

/***/ "./node_modules/lodash/toString.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__("./node_modules/lodash/_baseToString.js");
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),

/***/ "./node_modules/mitt/dist/mitt.js":
/***/ (function(module, exports) {

	function n(n){return n=n||Object.create(null),{on:function(t,o){(n[t]||(n[t]=[])).push(o)},off:function(t,o){n[t]&&n[t].splice(n[t].indexOf(o)>>>0,1)},emit:function(t,o){(n[t]||[]).map(function(n){n(o)}),(n["*"]||[]).map(function(n){n(t,o)})}}}module.exports=n;
	//# sourceMappingURL=mitt.js.map

/***/ }),

/***/ "./node_modules/modularscale/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.1
	var isNumber, ratios;
	
	isNumber = __webpack_require__("./node_modules/lodash.isnumber/index.js");
	
	ratios = {
	  "minor second": 16 / 15,
	  "major second": 9 / 8,
	  "minor third": 6 / 5,
	  "major third": 4 / 3,
	  "diminished fourth": Math.sqrt(2),
	  "perfect fifth": 3 / 2,
	  "minor sixth": 8 / 5,
	  "golden": 1.61803398875,
	  "phi": 1.61803398875,
	  "major sixth": 5 / 3,
	  "minor seventh": 16 / 9,
	  "major seventh": 15 / 8,
	  "octave": 2,
	  "major tenth": 5 / 2,
	  "major eleventh": 8 / 3,
	  "major twelfth": 3,
	  "double octave": 4
	};
	
	module.exports = function(value, ratio) {
	  var r;
	  if (value == null) {
	    value = 0;
	  }
	  if (ratio == null) {
	    ratio = "golden";
	  }
	  if (isNumber(ratio)) {
	    r = ratio;
	  } else if (ratios[ratio] != null) {
	    r = ratios[ratio];
	  } else {
	    r = ratios['golden'];
	  }
	  return Math.pow(r, value);
	};


/***/ }),

/***/ "./node_modules/parse-unit/index.js":
/***/ (function(module, exports) {

	module.exports = function parseUnit(str, out) {
	    if (!out)
	        out = [ 0, '' ]
	
	    str = String(str)
	    var num = parseFloat(str, 10)
	    out[0] = num
	    out[1] = str.match(/[\d.\-\+]*\s*(.*)/)[1] || ''
	    return out
	}

/***/ }),

/***/ "./node_modules/process/browser.js":
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ "./node_modules/typography-normalize/dist/index.js":
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable */
	/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css */
	exports.default = 'html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block}audio:not([controls]){display:none;height:0}progress{vertical-align:baseline}[hidden],template{display:none}a{background-color:transparent;-webkit-text-decoration-skip:objects}a:active,a:hover{outline-width:0}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:inherit;font-weight:bolder}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background-color:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}svg:not(:root){overflow:hidden}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}figure{margin:1em 40px}hr{box-sizing:content-box;height:0;overflow:visible}button,input,optgroup,select,textarea{font:inherit;margin:0}optgroup{font-weight:700}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-input-placeholder{color:inherit;opacity:.54}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}';

/***/ }),

/***/ "./node_modules/typography/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _objectAssign = __webpack_require__("./node_modules/object-assign/index.js");
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _compassVerticalRhythm = __webpack_require__("./node_modules/compass-vertical-rhythm/dist/index.js");
	
	var _compassVerticalRhythm2 = _interopRequireDefault(_compassVerticalRhythm);
	
	var _modularscale = __webpack_require__("./node_modules/modularscale/dist/index.js");
	
	var _modularscale2 = _interopRequireDefault(_modularscale);
	
	var _createStyles = __webpack_require__("./node_modules/typography/dist/utils/createStyles.js");
	
	var _createStyles2 = _interopRequireDefault(_createStyles);
	
	var _compileStyles = __webpack_require__("./node_modules/typography/dist/utils/compileStyles.js");
	
	var _compileStyles2 = _interopRequireDefault(_compileStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var typography = function typography(opts) {
	  var defaults = {
	    baseFontSize: '16px',
	    baseLineHeight: 1.45,
	    headerLineHeight: 1.1,
	    scaleRatio: 2,
	    googleFonts: [],
	    headerFontFamily: ['-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'sans-serif'],
	    bodyFontFamily: ['georgia', 'serif'],
	    headerColor: 'inherit',
	    bodyColor: 'hsla(0,0%,0%,0.8)',
	    headerWeight: 'bold',
	    bodyWeight: 'normal',
	    boldWeight: 'bold',
	    includeNormalize: true,
	    blockMarginBottom: 1
	  };
	
	  var options = (0, _objectAssign2.default)({}, defaults, opts);
	
	  var vr = (0, _compassVerticalRhythm2.default)(options);
	
	  // Add this function to the vertical rhythm object so it'll be passed around
	  // as well and be available. Not related really but this is the easiest
	  // way to pass around extra utility functions atm... :-\
	  vr.scale = function (value) {
	    // This doesn't pick the right scale ratio if a theme has more than one ratio.
	    // Perhaps add optional parameter for a width and it'll get the ratio
	    // for this width. Tricky part is maxWidth could be set in non-pixels.
	    var baseFont = parseInt(options.baseFontSize, 10);
	    var newFontSize = (0, _modularscale2.default)(value, options.scaleRatio) * baseFont + 'px';
	    return vr.adjustFontSizeTo(newFontSize);
	  };
	
	  return _extends({
	    options: options
	  }, vr, {
	    createStyles: function createStyles() {
	      return this.toString();
	    },
	    // TODO remove in next breaking release.
	    toJSON: function toJSON() {
	      return (0, _createStyles2.default)(vr, options);
	    },
	    toString: function toString() {
	      return (0, _compileStyles2.default)(vr, options, this.toJSON());
	    },
	    injectStyles: function injectStyles() {
	      if (typeof document !== 'undefined') {
	        // Replace existing
	        if (document.getElementById('typography.js')) {
	          var styleNode = document.getElementById('typography.js');
	          styleNode.innerHTML = this.toString();
	        } else {
	          var node = document.createElement('style');
	          node.id = 'typography.js';
	          node.innerHTML = this.toString();
	          document.head.appendChild(node);
	        }
	      }
	    }
	  });
	};
	
	module.exports = typography;
	
	/*
	const test = typography({
	  baseFontSize: '16px',
	  includeNormalize: false,
	})
	
	console.log(test.toJSON())
	console.log(test.toString())
	*/

/***/ }),

/***/ "./node_modules/typography/dist/utils/compileStyles.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typographyNormalize = __webpack_require__("./node_modules/typography-normalize/dist/index.js");
	
	var _typographyNormalize2 = _interopRequireDefault(_typographyNormalize);
	
	var _decamelize = __webpack_require__("./node_modules/decamelize/index.js");
	
	var _decamelize2 = _interopRequireDefault(_decamelize);
	
	var _forEach = __webpack_require__("./node_modules/lodash/forEach.js");
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _reduce = __webpack_require__("./node_modules/lodash/reduce.js");
	
	var _reduce2 = _interopRequireDefault(_reduce);
	
	var _isObject = __webpack_require__("./node_modules/lodash/isObject.js");
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var compileStyles = function compileStyles(styles) {
	  return (0, _reduce2.default)(styles, function (stylesStr, ruleSet, selector) {
	    stylesStr += selector + '{'; // eslint-disable-line
	    (0, _forEach2.default)(ruleSet, function (value, property) {
	      if ((0, _isObject2.default)(value)) {
	        var newObject = {};
	        newObject[property] = value;
	        stylesStr += compileStyles(newObject); // eslint-disable-line
	      } else {
	        var newStyle = (0, _decamelize2.default)(property, '-') + ':' + value + ';'; // eslint-disable-line
	        // If the property is prefixed, add an additional dash at the beginning.
	        var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	        prefixes.forEach(function (prefix) {
	          if (property.slice(0, prefix.length) === prefix) {
	            newStyle = '-' + newStyle;
	          }
	        });
	        stylesStr += newStyle;
	      }
	    });
	    stylesStr += '}'; // eslint-disable-line
	    return stylesStr;
	  }, '');
	};
	
	
	module.exports = function (vr, options, styles) {
	  // Compile styles to string.
	  var stylesStr = compileStyles(styles);
	
	  if (options.includeNormalize) {
	    stylesStr = '' + _typographyNormalize2.default + stylesStr;
	  }
	
	  return stylesStr;
	};

/***/ }),

/***/ "./node_modules/typography/dist/utils/createStyles.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _grayPercentage = __webpack_require__("./node_modules/gray-percentage/index.js");
	
	var _grayPercentage2 = _interopRequireDefault(_grayPercentage);
	
	var _set = __webpack_require__("./node_modules/lodash/set.js");
	
	var _set2 = _interopRequireDefault(_set);
	
	var _forEach = __webpack_require__("./node_modules/lodash/forEach.js");
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _isNumber = __webpack_require__("./node_modules/lodash/isNumber.js");
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _isString = __webpack_require__("./node_modules/lodash/isString.js");
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isFunction = __webpack_require__("./node_modules/lodash/isFunction.js");
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isArray = __webpack_require__("./node_modules/lodash/isArray.js");
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _merge = __webpack_require__("./node_modules/lodash/merge.js");
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _reduce = __webpack_require__("./node_modules/lodash/reduce.js");
	
	var _reduce2 = _interopRequireDefault(_reduce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setStyles = function setStyles() {
	  var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var els = arguments[1];
	  var rules = arguments[2];
	
	  var elements = void 0;
	  if (!(0, _isArray2.default)(els)) {
	    elements = [els];
	  } else {
	    elements = els;
	  }
	  (0, _forEach2.default)(elements, function (element) {
	    (0, _forEach2.default)(rules, function (value, prop) {
	      (0, _set2.default)(styles, element + "." + prop, value);
	    });
	  });
	  return styles;
	};
	
	// Wrap font names in quotes, unless the font name is actually a keyword.
	// See https://stackoverflow.com/a/13752149 and https://www.w3.org/TR/CSS2/fonts.html#font-family-prop
	var genericFontFamilies = ['inherit', 'default', 'serif', 'sans-serif', 'monospace', 'fantasy', 'cursive', '-apple-system'];
	var wrapFontFamily = function wrapFontFamily(fontFamily) {
	  return genericFontFamilies.indexOf(fontFamily) !== -1 ? fontFamily : "'" + fontFamily + "'";
	};
	
	module.exports = function (vr, options) {
	  var styles = {};
	
	  var _vr$establishBaseline = vr.establishBaseline(),
	      fontSize = _vr$establishBaseline.fontSize,
	      lineHeight = _vr$establishBaseline.lineHeight;
	
	  // Base HTML styles.
	
	
	  styles = setStyles(styles, "html", {
	    font: fontSize + "/" + lineHeight + " " + options.bodyFontFamily.map(wrapFontFamily).join(","),
	    boxSizing: "border-box",
	    overflowY: "scroll"
	  });
	
	  // box-sizing reset.
	  styles = setStyles(styles, ["*", "*:before", "*:after"], {
	    boxSizing: "inherit"
	  });
	
	  // Base body styles.
	  styles = setStyles(styles, "body", {
	    color: options.bodyColor,
	    fontFamily: options.bodyFontFamily.map(wrapFontFamily).join(","),
	    fontWeight: options.bodyWeight,
	    wordWrap: "break-word",
	    fontKerning: "normal",
	    MozFontFeatureSettings: '"kern", "liga", "clig", "calt"',
	    msFontFeatureSettings: '"kern", "liga", "clig", "calt"',
	    WebkitFontFeatureSettings: '"kern", "liga", "clig", "calt"',
	    fontFeatureSettings: '"kern", "liga", "clig", "calt"'
	  });
	
	  // Make images responsive.
	  styles = setStyles(styles, "img", {
	    maxWidth: "100%"
	  });
	
	  // All block elements get one rhythm of bottom margin by default
	  // or whatever is passed in as option.
	  var blockMarginBottom = "";
	  if ((0, _isNumber2.default)(options.blockMarginBottom)) {
	    blockMarginBottom = vr.rhythm(options.blockMarginBottom);
	  } else if ((0, _isString2.default)(options.blockMarginBottom)) {
	    blockMarginBottom = options.blockMarginBottom;
	  } else {
	    blockMarginBottom = vr.rhythm(1);
	  }
	  styles = setStyles(styles, ["h1", "h2", "h3", "h4", "h5", "h6", "hgroup", "ul", "ol", "dl", "dd", "p", "figure", "pre", "table", "fieldset", "blockquote", "form", "noscript", "iframe", "img", "hr", "address"], {
	    // Reset margin/padding to 0.
	    marginLeft: 0,
	    marginRight: 0,
	    marginTop: 0,
	    paddingBottom: 0,
	    paddingLeft: 0,
	    paddingRight: 0,
	    paddingTop: 0,
	    marginBottom: blockMarginBottom
	  });
	
	  // Basic blockquote styles.
	  styles = setStyles(styles, "blockquote", {
	    marginRight: vr.rhythm(1),
	    marginBottom: blockMarginBottom,
	    marginLeft: vr.rhythm(1)
	  });
	
	  // b, strong.
	  styles = setStyles(styles, ["b", "strong", "dt", "th"], {
	    fontWeight: options.boldWeight
	  });
	
	  // hr.
	  styles = setStyles(styles, "hr", {
	    background: (0, _grayPercentage2.default)(80),
	    border: "none",
	    height: "1px",
	    marginBottom: "calc(" + blockMarginBottom + " - 1px)"
	  });
	
	  // ol, ul.
	  styles = setStyles(styles, ["ol", "ul"], {
	    listStylePosition: "outside",
	    listStyleImage: "none",
	    marginLeft: vr.rhythm(1)
	  });
	
	  // li.
	  styles = setStyles(styles, "li", {
	    marginBottom: "calc(" + blockMarginBottom + " / 2)"
	  });
	
	  // Remove default padding on list items.
	  styles = setStyles(styles, ["ol li", "ul li"], {
	    paddingLeft: 0
	  });
	
	  // children ol, ul.
	  styles = setStyles(styles, ["li > ol", "li > ul"], {
	    marginLeft: vr.rhythm(1),
	    marginBottom: "calc(" + blockMarginBottom + " / 2)",
	    marginTop: "calc(" + blockMarginBottom + " / 2)"
	  });
	
	  // Remove margin-bottom on the last-child of a few block elements
	  // The worst offender of this seems to be markdown => html compilers
	  // as they put paragraphs within LIs amoung other oddities.
	  styles = setStyles(styles, ["blockquote *:last-child", "li *:last-child", "p *:last-child"], {
	    marginBottom: 0
	  });
	
	  // Ensure li > p is 1/2 margin — this is another markdown => compiler oddity.
	  styles = setStyles(styles, ["li > p"], {
	    marginBottom: "calc(" + blockMarginBottom + " / 2)"
	  });
	
	  // Make generally smaller elements, smaller.
	  styles = setStyles(styles, ["code", "kbd", "pre", "samp"], _extends({}, vr.adjustFontSizeTo("85%")));
	
	  // Abbr, Acronym.
	  styles = setStyles(styles, ["abbr", "acronym"], {
	    borderBottom: "1px dotted " + (0, _grayPercentage2.default)(50),
	    cursor: "help"
	  });
	  styles["abbr[title]"] = {
	    borderBottom: "1px dotted " + (0, _grayPercentage2.default)(50),
	    cursor: "help",
	    textDecoration: "none"
	  };
	
	  // Table styles.
	  styles = setStyles(styles, ["table"], _extends({}, vr.adjustFontSizeTo(options.baseFontSize), {
	    borderCollapse: "collapse",
	    width: "100%"
	  }));
	  styles = setStyles(styles, ["thead"], {
	    textAlign: "left"
	  });
	  styles = setStyles(styles, ["td,th"], {
	    textAlign: "left",
	    borderBottom: "1px solid " + (0, _grayPercentage2.default)(88),
	    fontFeatureSettings: '"tnum"',
	    MozFontFeatureSettings: '"tnum"',
	    msFontFeatureSettings: '"tnum"',
	    WebkitFontFeatureSettings: '"tnum"',
	    paddingLeft: vr.rhythm(2 / 3),
	    paddingRight: vr.rhythm(2 / 3),
	    paddingTop: vr.rhythm(1 / 2),
	    paddingBottom: "calc(" + vr.rhythm(1 / 2) + " - 1px)"
	  });
	  styles = setStyles(styles, "th:first-child,td:first-child", {
	    paddingLeft: 0
	  });
	  styles = setStyles(styles, "th:last-child,td:last-child", {
	    paddingRight: 0
	  });
	
	  // Create styles for headers.
	  styles = setStyles(styles, ["h1", "h2", "h3", "h4", "h5", "h6"], {
	    color: options.headerColor,
	    fontFamily: options.headerFontFamily.map(wrapFontFamily).join(","),
	    fontWeight: options.headerWeight,
	    textRendering: "optimizeLegibility"
	  });
	
	  // Set header sizes.
	  var h1 = vr.scale(5 / 5);
	  var h2 = vr.scale(3 / 5);
	  var h3 = vr.scale(2 / 5);
	  var h4 = vr.scale(0 / 5);
	  var h5 = vr.scale(-1 / 5);
	  var h6 = vr.scale(-1.5 / 5);
	
	  (0, _forEach2.default)([h1, h2, h3, h4, h5, h6], function (header, i) {
	    styles = (0, _set2.default)(styles, "h" + (i + 1) + ".fontSize", header.fontSize);
	    styles = (0, _set2.default)(styles, "h" + (i + 1) + ".lineHeight", options.headerLineHeight);
	  });
	
	  // TODO add support for Breakpoints here.
	
	  // Call plugins if any.
	  if ((0, _isArray2.default)(options.plugins)) {
	    styles = (0, _reduce2.default)(options.plugins, function (stylesObj, plugin) {
	      return (0, _merge2.default)(stylesObj, plugin(vr, options, stylesObj));
	    }, styles);
	  }
	
	  // Call overrideStyles function on options (if set).
	  if (options.overrideStyles && (0, _isFunction2.default)(options.overrideStyles)) {
	    styles = (0, _merge2.default)(styles, options.overrideStyles(vr, options, styles));
	  }
	
	  // Call overrideThemeStyles function on options (if set).
	  if (options.overrideThemeStyles && (0, _isFunction2.default)(options.overrideThemeStyles)) {
	    styles = (0, _merge2.default)(styles, options.overrideThemeStyles(vr, options, styles));
	  }
	
	  return styles;
	};

/***/ }),

/***/ "./node_modules/webpack/buildin/module.js":
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=component---src-pages-404-js!./src/pages/404.js":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(162898551421021, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dale/Documents/cp-website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-transform-object-assign/lib/index.js\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"glamor/babel-hoist\"],\"presets\":[[\"/Users/dale/Documents/cp-website/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/dale/Documents/cp-website/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/404.js") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=component---src-pages-blog-index-js!./src/pages/blog/index.js":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(152176518627018, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dale/Documents/cp-website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-transform-object-assign/lib/index.js\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"glamor/babel-hoist\"],\"presets\":[[\"/Users/dale/Documents/cp-website/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/dale/Documents/cp-website/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/blog/index.js") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=component---src-pages-case-studies-index-js!./src/pages/case-studies/index.js":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(53125558880568, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dale/Documents/cp-website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-transform-object-assign/lib/index.js\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"glamor/babel-hoist\"],\"presets\":[[\"/Users/dale/Documents/cp-website/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/dale/Documents/cp-website/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/case-studies/index.js") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=component---src-pages-contact-us-index-js!./src/pages/contact-us/index.js":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(221662759943617, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dale/Documents/cp-website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-transform-object-assign/lib/index.js\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"glamor/babel-hoist\"],\"presets\":[[\"/Users/dale/Documents/cp-website/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/dale/Documents/cp-website/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/contact-us/index.js") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=component---src-pages-features-index-js!./src/pages/features/index.js":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(72334677858794, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dale/Documents/cp-website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-transform-object-assign/lib/index.js\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"glamor/babel-hoist\"],\"presets\":[[\"/Users/dale/Documents/cp-website/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/dale/Documents/cp-website/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/features/index.js") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=component---src-pages-index-js!./src/pages/index.js":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(35783957827783, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dale/Documents/cp-website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-transform-object-assign/lib/index.js\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"glamor/babel-hoist\"],\"presets\":[[\"/Users/dale/Documents/cp-website/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/dale/Documents/cp-website/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/index.js") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=component---src-templates-blog-post-index-js!./src/templates/BlogPost/index.js":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(277928288978242, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dale/Documents/cp-website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-transform-object-assign/lib/index.js\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"glamor/babel-hoist\"],\"presets\":[[\"/Users/dale/Documents/cp-website/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/dale/Documents/cp-website/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/templates/BlogPost/index.js") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=component---src-templates-case-study-index-js!./src/templates/CaseStudy/index.js":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(86270741702289, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dale/Documents/cp-website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-transform-object-assign/lib/index.js\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"glamor/babel-hoist\"],\"presets\":[[\"/Users/dale/Documents/cp-website/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/dale/Documents/cp-website/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/templates/CaseStudy/index.js") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=component---src-templates-feature-index-js!./src/templates/Feature/index.js":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(238154550869096, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dale/Documents/cp-website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-transform-object-assign/lib/index.js\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"glamor/babel-hoist\"],\"presets\":[[\"/Users/dale/Documents/cp-website/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/dale/Documents/cp-website/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/templates/Feature/index.js") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./node_modules/gatsby-module-loader/index.js?name=component---src-templates-generic-post-index-js!./src/templates/GenericPost/index.js":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      "./node_modules/gatsby-module-loader/patch.js"
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(4940080089485, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__("./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dale/Documents/cp-website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-transform-object-assign/lib/index.js\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"glamor/babel-hoist\"],\"presets\":[[\"/Users/dale/Documents/cp-website/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/dale/Documents/cp-website/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/templates/GenericPost/index.js") })
	        }
	      });
	     }
	    

/***/ }),

/***/ "./src/utils/typography.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typography = __webpack_require__("./node_modules/typography/dist/index.js");
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _presets = __webpack_require__("./src/utils/presets.js");
	
	var _presets2 = _interopRequireDefault(_presets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var options = {
	  headerFontFamily: ['Circular Std', 'Helvetica Neue', 'Arial', 'sans-serif'],
	  bodyFontFamily: ['Circular Std', 'Helvetica Neue', 'Arial', 'sans-serif'],
	  monospaceFontFamily: ['Space Mono', 'SFMono-Regular', 'Menlo', 'Monaco', 'Consolas', 'Liberation Mono', 'Courier New', 'monospace'],
	  baseFontSize: '15px',
	  baseLineHeight: 1.4,
	  headerLineHeight: 1.075,
	  headerColor: '#70A4DB',
	  blockMarginBottom: 0.75,
	  scaleRatio: 2,
	  includeNormalize: false,
	  overrideStyles: function overrideStyles(_ref, options) {
	    var _ref2;
	
	    var rhythm = _ref.rhythm,
	        scale = _ref.scale;
	
	    return _ref2 = {
	      h1: {
	        color: '#70A4DB',
	        fontWeight: 'normal'
	      },
	      h2: {
	        color: '#70A4DB',
	        fontWeight: 'normal'
	      },
	      h3: {
	        fontWeight: 'normal',
	        color: '#70A4DB'
	      },
	      h4: _extends({}, scale(1 / 5)),
	      h5: {
	        fontSize: '15px',
	        fontWeight: 'bold',
	        lineHeight: '25px',
	        color: '#4F739A'
	      },
	      p: {
	        margin: '10px 0',
	        color: '#4A4A4A',
	        lineHeight: '25px'
	      },
	      'b, strong': {
	        color: '#9B9B9B'
	      },
	      a: {
	        color: '#70A4DB',
	        margin: '10px 0',
	        textDecoration: 'none',
	        '&:hover': {
	          textDecoration: 'underline'
	        }
	      },
	      hr: {
	        margin: '40px 0'
	      },
	      blockquote: {
	        padding: '10px 20px',
	        margin: '0 0 20px',
	        borderLeft: '5px solid #eee',
	        color: '#4F739A'
	      },
	      html: {
	        font: '',
	        fontSize: options.baseFontSize,
	        maxWidth: '100%',
	        width: '100%',
	        overflowX: 'hidden',
	        boxSizing: 'initial'
	      },
	      body: {
	        maxWidth: '100%',
	        width: '100%',
	        overflowX: 'hidden',
	        margin: 0
	      },
	      li: {
	        marginBottom: 0
	      },
	      '*': {
	        boxSizing: 'initial'
	      }
	    }, _ref2[_presets2.default.Desktop] = {
	      h1: {
	        fontSize: '36px',
	        lineHeight: '46px'
	      },
	      h2: {
	        fontSize: '32px',
	        lineHeight: '46px'
	      },
	      h3: {
	        fontSize: '18px'
	      },
	      blockquote: {
	        fontSize: '20px',
	        lineHeight: '35px'
	      }
	    }, _ref2[_presets2.default.Tablet] = {
	      h1: {
	        fontSize: '36px',
	        lineHeight: '46px'
	      },
	      h2: {
	        fontSize: '32px',
	        lineHeight: '46px'
	      },
	      h3: {
	        fontSize: '18px',
	        margin: '10px 0'
	      },
	      blockquote: {
	        fontSize: '18px',
	        lineHeight: '30px'
	      }
	    }, _ref2[_presets2.default.Mobile] = {
	      h1: {
	        fontSize: '24px',
	        lineHeight: '40px'
	      },
	      h2: {
	        fontSize: '24px',
	        lineHeight: '40px'
	      },
	      h3: {
	        fontSize: '16px',
	        lineHeight: '30px',
	        margin: '5px 0'
	      },
	      blockquote: {
	        fontSize: '16px',
	        lineHeight: '30px'
	      }
	    }, _ref2;
	  }
	};
	
	var typography = new _typography2.default(options);
	
	exports.default = typography;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// app-0506cc13358f2e9f023c.js